import React from 'react';

const Decor4: React.FC = () => {
  return (
    <g
      className="prefix__map-decor-4 prefix__map-decor"
      transform="translate(396.5 256.2)"
    >
      <defs>
        <linearGradient
          id="e89a3567-cdcd-444f-82a1-5dcfaf1116ea"
          data-name="grad-190"
          x1="98.21"
          y1="47.38"
          x2="98.19"
          y2="50.94"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.22" stopColor="#35323c" />
          <stop offset="0.43" stopColor="#7a7a42" />
          <stop offset="0.63" stopColor="#b1b347" />
          <stop offset="0.79" stopColor="#d9dc4a" />
          <stop offset="0.92" stopColor="#f1f64c" />
          <stop offset="1" stopColor="#faff4d" />
        </linearGradient>
        <linearGradient
          id="e635fb1a-0e50-4711-91c3-92d3b79701ea"
          data-name="grad-198"
          x1="98.18"
          y1="48.18"
          x2="98.21"
          y2="52.46"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.27" stopColor="#4b4945" />
          <stop offset="0.47" stopColor="#8d8d51" />
          <stop offset="0.63" stopColor="#bdbf5a" />
          <stop offset="0.75" stopColor="#dadd60" />
          <stop offset="0.82" stopColor="#e5e962" />
          <stop offset="1" stopColor="#faff64" />
        </linearGradient>
        <linearGradient
          id="f4f57ce6-63e9-423e-897e-249ce3ccab91"
          data-name="grad-197"
          x1="98.14"
          y1="48.99"
          x2="98.23"
          y2="53.83"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.17" stopColor="#272341" />
          <stop offset="0.41" stopColor="#7a7959" />
          <stop offset="0.61" stopColor="#b7b86a" />
          <stop offset="0.75" stopColor="#dddf75" />
          <stop offset="0.82" stopColor="#ebee79" />
          <stop offset="1" stopColor="#fbff7b" />
        </linearGradient>
        <linearGradient
          id="bbd35fee-04c0-4db3-bbff-778729a0e7e7"
          data-name="grad-196"
          x1="98.09"
          y1="49.81"
          x2="98.25"
          y2="55.07"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.31" stopColor="#565456" />
          <stop offset="0.56" stopColor="#a8a975" />
          <stop offset="0.74" stopColor="#dcdf89" />
          <stop offset="0.82" stopColor="#f0f491" />
          <stop offset="1" stopColor="#fbff91" />
        </linearGradient>
        <linearGradient
          id="a2a8a5d6-c129-4e66-91ad-f4090541bfbc"
          data-name="grad-195"
          x1="98.02"
          y1="50.65"
          x2="98.26"
          y2="56.16"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.44" stopColor="#818070" />
          <stop offset="0.7" stopColor="#d5d798" />
          <stop offset="0.82" stopColor="#f6f9a8" />
          <stop offset="1" stopColor="#fcffa8" />
        </linearGradient>
        <linearGradient
          id="efaa2f42-0c2e-4fe3-bed7-07ed9175b84b"
          data-name="grad-47"
          x1="97.95"
          y1="51.48"
          x2="98.25"
          y2="57.09"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.54" stopColor="#a3a38d" />
          <stop offset="0.82" stopColor="#fcffbf" />
        </linearGradient>
        <linearGradient
          id="ab93240b-13a1-45fd-b693-3cb00e732a3b"
          data-name="grad-194"
          x1="98.02"
          y1="53.78"
          x2="98.26"
          y2="59.52"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.2" stopColor="#332f4b" />
          <stop offset="0.43" stopColor="#888773" />
          <stop offset="0.62" stopColor="#c6c891" />
          <stop offset="0.75" stopColor="#ecf0a3" />
          <stop offset="0.82" stopColor="#fbffaa" />
        </linearGradient>
        <linearGradient
          id="af91c3e1-a333-4e57-8834-202cd03826c0"
          data-name="grad-193"
          x1="98.08"
          y1="56.07"
          x2="98.25"
          y2="61.84"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.25" stopColor="#4d4b53" />
          <stop offset="0.4" stopColor="#8a8a6a" />
          <stop offset="0.54" stopColor="#babd7d" />
          <stop offset="0.66" stopColor="#dde18b" />
          <stop offset="0.76" stopColor="#f2f793" />
          <stop offset="0.82" stopColor="#faff96" />
        </linearGradient>
        <linearGradient
          id="a4982ff0-f7c2-4955-9ce0-c3151e4c0ae8"
          data-name="grad-192"
          x1="98.13"
          y1="58.36"
          x2="98.23"
          y2="64.06"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.22" stopColor="#4a484c" />
          <stop offset="0.34" stopColor="#7f805c" />
          <stop offset="0.45" stopColor="#abad69" />
          <stop offset="0.56" stopColor="#cdd174" />
          <stop offset="0.66" stopColor="#e5ea7b" />
          <stop offset="0.75" stopColor="#f4fa7f" />
          <stop offset="0.82" stopColor="#f9ff81" />
        </linearGradient>
        <linearGradient
          id="a3a0f4f9-c667-4c37-9c11-66e3132f4938"
          data-name="grad-191"
          x1="98.17"
          y1="60.66"
          x2="98.21"
          y2="66.17"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.18" stopColor="#403d44" />
          <stop offset="0.27" stopColor="#70704f" />
          <stop offset="0.36" stopColor="#9a9c58" />
          <stop offset="0.45" stopColor="#bcc060" />
          <stop offset="0.54" stopColor="#d6db66" />
          <stop offset="0.64" stopColor="#e9ef6a" />
          <stop offset="0.73" stopColor="#f4fb6c" />
          <stop offset="0.82" stopColor="#f8ff6d" />
        </linearGradient>
        <linearGradient
          id="fb82e76a-9219-4737-83bf-2576884788ec"
          data-name="grad-126"
          x1="98.21"
          y1="62.96"
          x2="98.18"
          y2="68.2"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.14" stopColor="#302d3e" />
          <stop offset="0.21" stopColor="#5e5e44" />
          <stop offset="0.28" stopColor="#878949" />
          <stop offset="0.35" stopColor="#aaae4e" />
          <stop offset="0.43" stopColor="#c6cb52" />
          <stop offset="0.51" stopColor="#dce254" />
          <stop offset="0.6" stopColor="#ebf256" />
          <stop offset="0.69" stopColor="#f4fc58" />
          <stop offset="0.82" stopColor="#f7ff58" />
        </linearGradient>
        <radialGradient
          id="b05ab004-8ce9-4584-a01e-6b1d8adfaab6"
          data-name="grad-210"
          cx="98"
          cy="57"
          r="19"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.01" stopColor="#ebff41" stopOpacity="0.6" />
          <stop offset="0.27" stopColor="#f2ff7d" stopOpacity="0.39" />
          <stop offset="0.58" stopColor="#f9ffbc" stopOpacity="0.18" />
          <stop offset="0.81" stopColor="#fdffe2" stopOpacity="0.05" />
          <stop offset="0.94" stopColor="#fffff1" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id="f459655f-2d9a-4dd9-a75f-e6bb62aa8803"
          x1="407.8"
          y1="6.26"
          x2="407.79"
          y2="8.63"
          xlinkHref="#e89a3567-cdcd-444f-82a1-5dcfaf1116ea"
        />
        <linearGradient
          id="be0663e3-fac5-4bb6-a39b-3d9a6a301c1c"
          x1="407.79"
          y1="6.78"
          x2="407.8"
          y2="9.64"
          xlinkHref="#e635fb1a-0e50-4711-91c3-92d3b79701ea"
        />
        <linearGradient
          id="b3894309-af56-4386-883d-e2b612672bbc"
          x1="407.76"
          y1="7.33"
          x2="407.82"
          y2="10.56"
          xlinkHref="#f4f57ce6-63e9-423e-897e-249ce3ccab91"
        />
        <linearGradient
          id="e890105f-f49d-4665-9cf9-3e8675ccea91"
          x1="407.72"
          y1="7.88"
          x2="407.83"
          y2="11.38"
          xlinkHref="#bbd35fee-04c0-4db3-bbff-778729a0e7e7"
        />
        <linearGradient
          id="f8db90fe-15b7-4ee4-968a-5015553b7b1d"
          x1="407.68"
          y1="8.43"
          x2="407.84"
          y2="12.11"
          xlinkHref="#a2a8a5d6-c129-4e66-91ad-f4090541bfbc"
        />
        <linearGradient
          id="eb99e571-06ee-4732-a2a9-50c924e6a882"
          x1="407.63"
          y1="8.99"
          x2="407.83"
          y2="12.73"
          xlinkHref="#efaa2f42-0c2e-4fe3-bed7-07ed9175b84b"
        />
        <linearGradient
          id="a7de5b65-8914-4fbe-b135-2372e4fdb166"
          x1="407.68"
          y1="10.52"
          x2="407.84"
          y2="14.35"
          xlinkHref="#ab93240b-13a1-45fd-b693-3cb00e732a3b"
        />
        <linearGradient
          id="e5467920-bc4b-4747-9eba-8e7e367e836a"
          x1="407.72"
          y1="12.05"
          x2="407.83"
          y2="15.89"
          xlinkHref="#af91c3e1-a333-4e57-8834-202cd03826c0"
        />
        <linearGradient
          id="a451f3a7-a795-4377-841b-c1f11a6d1081"
          x1="407.75"
          y1="13.58"
          x2="407.82"
          y2="17.37"
          xlinkHref="#a4982ff0-f7c2-4955-9ce0-c3151e4c0ae8"
        />
        <linearGradient
          id="a96fe636-1aa6-4b99-8bb0-0727234e2b26"
          x1="407.78"
          y1="15.11"
          x2="407.81"
          y2="18.78"
          xlinkHref="#a3a0f4f9-c667-4c37-9c11-66e3132f4938"
        />
        <linearGradient
          id="e2142895-2e21-4cc4-98a3-7ad6ebef33b6"
          x1="407.81"
          y1="16.64"
          x2="407.79"
          y2="20.13"
          xlinkHref="#fb82e76a-9219-4737-83bf-2576884788ec"
        />
        <radialGradient
          id="fff11dcd-58e1-4e60-b6ff-bdb7582e978e"
          cx="407.67"
          cy="12.67"
          r="12.67"
          xlinkHref="#b05ab004-8ce9-4584-a01e-6b1d8adfaab6"
        />
        <linearGradient
          id="fa396f17-1df6-4532-810a-e21cd5fa8d28"
          x1="19.21"
          y1="77.38"
          x2="19.19"
          y2="80.94"
          xlinkHref="#e89a3567-cdcd-444f-82a1-5dcfaf1116ea"
        />
        <linearGradient
          id="b320cd29-9941-405c-90ca-1439e3b112ed"
          x1="19.18"
          y1="78.18"
          x2="19.21"
          y2="82.46"
          xlinkHref="#e635fb1a-0e50-4711-91c3-92d3b79701ea"
        />
        <linearGradient
          id="e472634b-89c6-4181-81ba-0f1adc7c8924"
          x1="19.14"
          y1="78.99"
          x2="19.23"
          y2="83.83"
          xlinkHref="#f4f57ce6-63e9-423e-897e-249ce3ccab91"
        />
        <linearGradient
          id="b3824da3-3697-4c96-ba3a-421f4489a908"
          x1="19.09"
          y1="79.81"
          x2="19.25"
          y2="85.07"
          xlinkHref="#bbd35fee-04c0-4db3-bbff-778729a0e7e7"
        />
        <linearGradient
          id="bb6d2292-171e-4f26-9bf1-83adfd212255"
          x1="19.02"
          y1="80.65"
          x2="19.26"
          y2="86.16"
          xlinkHref="#a2a8a5d6-c129-4e66-91ad-f4090541bfbc"
        />
        <linearGradient
          id="fd1255f2-828d-4cfa-95a3-cd250b035c55"
          x1="18.95"
          y1="81.48"
          x2="19.25"
          y2="87.09"
          xlinkHref="#efaa2f42-0c2e-4fe3-bed7-07ed9175b84b"
        />
        <linearGradient
          id="bfb72319-14e1-4542-bed1-aec803dd7de7"
          x1="19.02"
          y1="83.78"
          x2="19.26"
          y2="89.52"
          xlinkHref="#ab93240b-13a1-45fd-b693-3cb00e732a3b"
        />
        <linearGradient
          id="ae00f2f2-42fc-4d64-944f-35edcdcb8cdf"
          x1="19.08"
          y1="86.07"
          x2="19.25"
          y2="91.84"
          xlinkHref="#af91c3e1-a333-4e57-8834-202cd03826c0"
        />
        <linearGradient
          id="bcd22b77-1c5c-4f4f-bf44-3230ef81bab6"
          x1="19.13"
          y1="88.36"
          x2="19.23"
          y2="94.06"
          xlinkHref="#a4982ff0-f7c2-4955-9ce0-c3151e4c0ae8"
        />
        <linearGradient
          id="f988dff4-1c15-4e8d-aadb-805e09fa3333"
          x1="19.17"
          y1="90.66"
          x2="19.21"
          y2="96.17"
          xlinkHref="#a3a0f4f9-c667-4c37-9c11-66e3132f4938"
        />
        <linearGradient
          id="bcd59f11-29ca-46b3-816f-dc03b7e7e324"
          x1="19.21"
          y1="92.96"
          x2="19.18"
          y2="98.2"
          xlinkHref="#fb82e76a-9219-4737-83bf-2576884788ec"
        />
        <radialGradient
          id="ac444d1b-bebf-4db5-9cf0-11febd97d416"
          cx="19"
          cy="87"
          xlinkHref="#b05ab004-8ce9-4584-a01e-6b1d8adfaab6"
        />
        <linearGradient
          id="b243b76a-f6c7-48d2-a2b5-8b56eded842e"
          x1="565.8"
          y1="60.26"
          x2="565.79"
          y2="62.63"
          xlinkHref="#e89a3567-cdcd-444f-82a1-5dcfaf1116ea"
        />
        <linearGradient
          id="f142f55d-12ba-4118-bd94-f89b6a32f7e2"
          x1="565.79"
          y1="60.78"
          x2="565.8"
          y2="63.64"
          xlinkHref="#e635fb1a-0e50-4711-91c3-92d3b79701ea"
        />
        <linearGradient
          id="ae31a380-1e86-493a-acd4-c5f096a7f537"
          x1="565.76"
          y1="61.33"
          x2="565.82"
          y2="64.56"
          xlinkHref="#f4f57ce6-63e9-423e-897e-249ce3ccab91"
        />
        <linearGradient
          id="b73f62c8-32a5-45fe-a7b0-7d34d40ba0a7"
          x1="565.72"
          y1="61.88"
          x2="565.83"
          y2="65.38"
          xlinkHref="#bbd35fee-04c0-4db3-bbff-778729a0e7e7"
        />
        <linearGradient
          id="b1d0ed6f-cc03-4984-9b17-4ba1a45f4cec"
          x1="565.68"
          y1="62.43"
          x2="565.84"
          y2="66.11"
          xlinkHref="#a2a8a5d6-c129-4e66-91ad-f4090541bfbc"
        />
        <linearGradient
          id="ecfcb09a-e141-422f-bd0a-ae8d5ffcc317"
          x1="565.63"
          y1="62.99"
          x2="565.83"
          y2="66.73"
          xlinkHref="#efaa2f42-0c2e-4fe3-bed7-07ed9175b84b"
        />
        <linearGradient
          id="a5ec692b-8f0f-44d0-b709-dec42809c0fe"
          x1="565.68"
          y1="64.52"
          x2="565.84"
          y2="68.35"
          xlinkHref="#ab93240b-13a1-45fd-b693-3cb00e732a3b"
        />
        <linearGradient
          id="f1abcf51-0840-464b-a19c-39983dbe140a"
          x1="565.72"
          y1="66.05"
          x2="565.83"
          y2="69.89"
          xlinkHref="#af91c3e1-a333-4e57-8834-202cd03826c0"
        />
        <linearGradient
          id="af5eb6b5-7bd6-4225-b950-f61892d7d40f"
          x1="565.75"
          y1="67.58"
          x2="565.82"
          y2="71.37"
          xlinkHref="#a4982ff0-f7c2-4955-9ce0-c3151e4c0ae8"
        />
        <linearGradient
          id="b5b23f0c-e8e2-4bec-95d1-9a7038103724"
          x1="565.78"
          y1="69.11"
          x2="565.81"
          y2="72.78"
          xlinkHref="#a3a0f4f9-c667-4c37-9c11-66e3132f4938"
        />
        <linearGradient
          id="fed4183e-8b8b-4d79-bbc6-6f45a9ed594e"
          x1="565.81"
          y1="70.64"
          x2="565.79"
          y2="74.13"
          xlinkHref="#fb82e76a-9219-4737-83bf-2576884788ec"
        />
        <radialGradient
          id="ab08811f-fd25-4455-ae98-5d2940b91aaa"
          cx="565.67"
          cy="66.67"
          r="12.67"
          xlinkHref="#b05ab004-8ce9-4584-a01e-6b1d8adfaab6"
        />
        <linearGradient
          id="f577a9e1-199e-4dc2-b078-3c89441bd094"
          x1="591.8"
          y1="26.26"
          x2="591.79"
          y2="28.63"
          xlinkHref="#e89a3567-cdcd-444f-82a1-5dcfaf1116ea"
        />
        <linearGradient
          id="a3475e1b-3001-4d71-ba63-8a6a8a24e846"
          x1="591.79"
          y1="26.78"
          x2="591.8"
          y2="29.64"
          xlinkHref="#e635fb1a-0e50-4711-91c3-92d3b79701ea"
        />
        <linearGradient
          id="bb53b05e-3826-404f-90da-0fcdf68d5d7b"
          x1="591.76"
          y1="27.33"
          x2="591.82"
          y2="30.56"
          xlinkHref="#f4f57ce6-63e9-423e-897e-249ce3ccab91"
        />
        <linearGradient
          id="ae3e8ec6-5097-4f42-b45f-727db9361b58"
          x1="591.72"
          y1="27.88"
          x2="591.83"
          y2="31.38"
          xlinkHref="#bbd35fee-04c0-4db3-bbff-778729a0e7e7"
        />
        <linearGradient
          id="b827238b-be9c-454c-828b-64f1f84f69e5"
          x1="591.68"
          y1="28.43"
          x2="591.84"
          y2="32.11"
          xlinkHref="#a2a8a5d6-c129-4e66-91ad-f4090541bfbc"
        />
        <linearGradient
          id="f65e846b-2545-4dce-8317-c0c6a1767b15"
          x1="591.63"
          y1="28.99"
          x2="591.83"
          y2="32.73"
          xlinkHref="#efaa2f42-0c2e-4fe3-bed7-07ed9175b84b"
        />
        <linearGradient
          id="a1f7457a-41e7-4cb9-a2aa-318455ebc7e3"
          x1="591.68"
          y1="30.52"
          x2="591.84"
          y2="34.35"
          xlinkHref="#ab93240b-13a1-45fd-b693-3cb00e732a3b"
        />
        <linearGradient
          id="ebdb7a5c-ff4d-4017-b065-0933d7c65446"
          x1="591.72"
          y1="32.05"
          x2="591.83"
          y2="35.89"
          xlinkHref="#af91c3e1-a333-4e57-8834-202cd03826c0"
        />
        <linearGradient
          id="f7582799-d9e8-400c-8ab8-53aa02f19823"
          x1="591.75"
          y1="33.58"
          x2="591.82"
          y2="37.37"
          xlinkHref="#a4982ff0-f7c2-4955-9ce0-c3151e4c0ae8"
        />
        <linearGradient
          id="a958cca7-fe9c-4b76-a695-d85d8efaff7d"
          x1="591.78"
          y1="35.11"
          x2="591.81"
          y2="38.78"
          xlinkHref="#a3a0f4f9-c667-4c37-9c11-66e3132f4938"
        />
        <linearGradient
          id="b2d9e1a4-96d1-4fc9-b350-72b2044c484c"
          x1="591.81"
          y1="36.64"
          x2="591.79"
          y2="40.13"
          xlinkHref="#fb82e76a-9219-4737-83bf-2576884788ec"
        />
        <radialGradient
          id="b35272eb-dd59-41a1-af57-180f7a4ef154"
          cx="591.67"
          cy="32.67"
          r="12.67"
          xlinkHref="#b05ab004-8ce9-4584-a01e-6b1d8adfaab6"
        />
        <linearGradient
          id="a0b4b78b-b59e-4ab3-9407-4a3b04ee7acc"
          x1="878.42"
          y1="38.42"
          x2="878.38"
          y2="45.72"
          xlinkHref="#e89a3567-cdcd-444f-82a1-5dcfaf1116ea"
        />
        <linearGradient
          id="b67a3ebd-4011-437b-9eea-7fd872f448b6"
          x1="878.37"
          y1="40.04"
          x2="878.42"
          y2="48.83"
          xlinkHref="#e635fb1a-0e50-4711-91c3-92d3b79701ea"
        />
        <linearGradient
          id="af337c61-5d8c-4708-a95b-8aed2df6b5ab"
          x1="878.28"
          y1="41.71"
          x2="878.47"
          y2="51.66"
          xlinkHref="#f4f57ce6-63e9-423e-897e-249ce3ccab91"
        />
        <linearGradient
          id="e9d0bd06-25fa-4361-9e66-fb6dccbd2d6f"
          data-name="grad-28"
          x1="878.18"
          y1="43.41"
          x2="878.51"
          y2="54.19"
          xlinkHref="#bbd35fee-04c0-4db3-bbff-778729a0e7e7"
        />
        <linearGradient
          id="ad804521-10ed-483a-a60f-e7c11262501f"
          data-name="grad-26"
          x1="878.05"
          y1="45.12"
          x2="878.53"
          y2="56.43"
          xlinkHref="#a2a8a5d6-c129-4e66-91ad-f4090541bfbc"
        />
        <linearGradient
          id="a255bdbd-256f-4966-8f53-7eef964cd874"
          x1="877.89"
          y1="46.84"
          x2="878.52"
          y2="58.34"
          xlinkHref="#efaa2f42-0c2e-4fe3-bed7-07ed9175b84b"
        />
        <linearGradient
          id="add647cc-fb2f-475c-a110-ecd0a19f9be8"
          x1="878.03"
          y1="51.55"
          x2="878.53"
          y2="63.33"
          xlinkHref="#ab93240b-13a1-45fd-b693-3cb00e732a3b"
        />
        <linearGradient
          id="a5df2b88-6415-4bdc-9785-75a52967b1fa"
          x1="878.16"
          y1="56.25"
          x2="878.52"
          y2="68.09"
          xlinkHref="#af91c3e1-a333-4e57-8834-202cd03826c0"
        />
        <linearGradient
          id="e8aa6f05-e69e-4058-acff-46f3a46045bd"
          x1="878.26"
          y1="60.96"
          x2="878.48"
          y2="72.64"
          xlinkHref="#a4982ff0-f7c2-4955-9ce0-c3151e4c0ae8"
        />
        <linearGradient
          id="ff2cf141-915f-4477-9556-a8792fbf07ea"
          x1="878.36"
          y1="65.67"
          x2="878.43"
          y2="76.99"
          xlinkHref="#a3a0f4f9-c667-4c37-9c11-66e3132f4938"
        />
        <linearGradient
          id="fb9c79e0-df4f-4d04-9d4d-eb5632df79ed"
          x1="878.43"
          y1="70.4"
          x2="878.37"
          y2="81.14"
          xlinkHref="#fb82e76a-9219-4737-83bf-2576884788ec"
        />
        <radialGradient
          id="a7b7019b-d50e-4a43-b901-de7c9217e05e"
          cx="878"
          cy="58.16"
          r="39"
          xlinkHref="#b05ab004-8ce9-4584-a01e-6b1d8adfaab6"
        />
        <linearGradient
          id="a9b0dd84-6e46-4f94-b634-2ba9788bb17c"
          x1="869.42"
          y1="179.42"
          x2="869.38"
          y2="186.72"
          xlinkHref="#e89a3567-cdcd-444f-82a1-5dcfaf1116ea"
        />
        <linearGradient
          id="e90b0f65-b6a5-4cdb-9472-aca300ffa460"
          x1="869.37"
          y1="181.04"
          x2="869.42"
          y2="189.83"
          xlinkHref="#e635fb1a-0e50-4711-91c3-92d3b79701ea"
        />
        <linearGradient
          id="b568e9ce-eec1-4118-b7e0-07ba79ef7099"
          x1="869.28"
          y1="182.71"
          x2="869.47"
          y2="192.66"
          xlinkHref="#f4f57ce6-63e9-423e-897e-249ce3ccab91"
        />
        <linearGradient
          id="a38e94fa-6742-4685-a522-df83c252e059"
          x1="869.18"
          y1="184.41"
          x2="869.51"
          y2="195.19"
          xlinkHref="#bbd35fee-04c0-4db3-bbff-778729a0e7e7"
        />
        <linearGradient
          id="a85ab821-b9ff-4f79-b62e-839c4bd22382"
          x1="869.05"
          y1="186.12"
          x2="869.53"
          y2="197.43"
          xlinkHref="#a2a8a5d6-c129-4e66-91ad-f4090541bfbc"
        />
        <linearGradient
          id="e6ae38ee-67ec-4d50-a71d-bfa7465c07f7"
          x1="868.89"
          y1="187.84"
          x2="869.52"
          y2="199.34"
          xlinkHref="#efaa2f42-0c2e-4fe3-bed7-07ed9175b84b"
        />
        <linearGradient
          id="a55c0e41-873c-4e4d-97cb-c45c76c86216"
          x1="869.03"
          y1="192.55"
          x2="869.53"
          y2="204.33"
          xlinkHref="#ab93240b-13a1-45fd-b693-3cb00e732a3b"
        />
        <linearGradient
          id="fa6af71d-8870-4b55-9cae-4cecc74a53bd"
          x1="869.16"
          y1="197.25"
          x2="869.52"
          y2="209.09"
          xlinkHref="#af91c3e1-a333-4e57-8834-202cd03826c0"
        />
        <linearGradient
          id="a5bd624f-6b25-466c-908a-27a24465f0d3"
          x1="869.26"
          y1="201.96"
          x2="869.48"
          y2="213.64"
          xlinkHref="#a4982ff0-f7c2-4955-9ce0-c3151e4c0ae8"
        />
        <linearGradient
          id="ba672f8f-ba66-44bb-908a-b42f85317b39"
          x1="869.36"
          y1="206.67"
          x2="869.43"
          y2="217.99"
          xlinkHref="#a3a0f4f9-c667-4c37-9c11-66e3132f4938"
        />
        <linearGradient
          id="e35e5631-e720-46d5-a441-91a225dd6e37"
          x1="869.43"
          y1="211.4"
          x2="869.37"
          y2="222.14"
          xlinkHref="#fb82e76a-9219-4737-83bf-2576884788ec"
        />
        <radialGradient
          id="b4b64e32-5db3-445c-a609-83f6f5e147e2"
          cx="869"
          cy="199.16"
          r="39"
          xlinkHref="#b05ab004-8ce9-4584-a01e-6b1d8adfaab6"
        />
        <linearGradient
          id="fabcea19-7839-4f63-bae5-8966340f1494"
          x1="228.21"
          y1="27.38"
          x2="228.19"
          y2="30.94"
          xlinkHref="#e89a3567-cdcd-444f-82a1-5dcfaf1116ea"
        />
        <linearGradient
          id="bb975892-7ec6-4436-ba5f-b9ed66a870a5"
          x1="228.18"
          y1="28.18"
          x2="228.21"
          y2="32.46"
          xlinkHref="#e635fb1a-0e50-4711-91c3-92d3b79701ea"
        />
        <linearGradient
          id="b0615de8-43cc-4e2a-b640-ca08860867dc"
          x1="228.14"
          y1="28.99"
          x2="228.23"
          y2="33.83"
          xlinkHref="#f4f57ce6-63e9-423e-897e-249ce3ccab91"
        />
        <linearGradient
          id="becf2053-0de1-4516-90be-51955962a905"
          x1="228.09"
          y1="29.81"
          x2="228.25"
          y2="35.07"
          xlinkHref="#bbd35fee-04c0-4db3-bbff-778729a0e7e7"
        />
        <linearGradient
          id="b67441f8-64ba-4bee-9b53-4e2d12397581"
          x1="228.02"
          y1="30.65"
          x2="228.26"
          y2="36.16"
          xlinkHref="#a2a8a5d6-c129-4e66-91ad-f4090541bfbc"
        />
        <linearGradient
          id="be59a214-4223-4739-9640-4e8c04674d04"
          x1="227.95"
          y1="31.48"
          x2="228.25"
          y2="37.09"
          xlinkHref="#efaa2f42-0c2e-4fe3-bed7-07ed9175b84b"
        />
        <linearGradient
          id="b847d2c3-2a37-4d26-97bc-a0c6abc6fb3b"
          x1="228.02"
          y1="33.78"
          x2="228.26"
          y2="39.52"
          xlinkHref="#ab93240b-13a1-45fd-b693-3cb00e732a3b"
        />
        <linearGradient
          id="ec58e84a-cea0-4a9f-baec-6fb7ffe98f2b"
          x1="228.08"
          y1="36.07"
          x2="228.25"
          y2="41.84"
          xlinkHref="#af91c3e1-a333-4e57-8834-202cd03826c0"
        />
        <linearGradient
          id="b686e5fd-cf22-4887-9fd2-cd0a503b43c3"
          x1="228.13"
          y1="38.36"
          x2="228.23"
          y2="44.06"
          xlinkHref="#a4982ff0-f7c2-4955-9ce0-c3151e4c0ae8"
        />
        <linearGradient
          id="b7c8b974-39eb-4334-bfe4-311f10ef63f8"
          x1="228.17"
          y1="40.66"
          x2="228.21"
          y2="46.17"
          xlinkHref="#a3a0f4f9-c667-4c37-9c11-66e3132f4938"
        />
        <linearGradient
          id="b75ea7aa-3199-4791-a9c7-c901e2ecdafb"
          x1="228.21"
          y1="42.96"
          x2="228.18"
          y2="48.2"
          xlinkHref="#fb82e76a-9219-4737-83bf-2576884788ec"
        />
        <radialGradient
          id="a32a3007-e261-434c-9acc-5bc9f23d39f1"
          cx="228"
          cy="37"
          xlinkHref="#b05ab004-8ce9-4584-a01e-6b1d8adfaab6"
        />
      </defs>
      <g>
        <g>
          <rect
            x="97.24"
            y="58.29"
            width="1.91"
            height="33.71"
            rx="0.95"
            fill="#a39bb2"
          />
          <g>
            <ellipse
              cx="98.19"
              cy="49.36"
              rx="3.91"
              ry="0.77"
              fill="url(#e89a3567-cdcd-444f-82a1-5dcfaf1116ea)"
            />
            <ellipse
              cx="98.19"
              cy="50.7"
              rx="5.39"
              ry="1.01"
              fill="url(#e635fb1a-0e50-4711-91c3-92d3b79701ea)"
            />
            <ellipse
              cx="98.19"
              cy="52.03"
              rx="6.88"
              ry="1.25"
              fill="url(#f4f57ce6-63e9-423e-897e-249ce3ccab91)"
            />
            <ellipse
              cx="98.19"
              cy="53.37"
              rx="8.36"
              ry="1.49"
              fill="url(#bbd35fee-04c0-4db3-bbff-778729a0e7e7)"
            />
            <ellipse
              cx="98.19"
              cy="54.7"
              rx="9.84"
              ry="1.72"
              fill="url(#a2a8a5d6-c129-4e66-91ad-f4090541bfbc)"
            />
            <ellipse
              cx="98.19"
              cy="56.04"
              rx="11.33"
              ry="1.96"
              fill="url(#efaa2f42-0c2e-4fe3-bed7-07ed9175b84b)"
            />
            <ellipse
              cx="98.19"
              cy="58"
              rx="10.21"
              ry="1.8"
              fill="url(#ab93240b-13a1-45fd-b693-3cb00e732a3b)"
            />
            <ellipse
              cx="98.19"
              cy="59.97"
              rx="9.1"
              ry="1.63"
              fill="url(#af91c3e1-a333-4e57-8834-202cd03826c0)"
            />
            <ellipse
              cx="98.19"
              cy="61.94"
              rx="7.99"
              ry="1.46"
              fill="url(#a4982ff0-f7c2-4955-9ce0-c3151e4c0ae8)"
            />
            <ellipse
              cx="98.19"
              cy="63.91"
              rx="6.87"
              ry="1.3"
              fill="url(#a3a0f4f9-c667-4c37-9c11-66e3132f4938)"
            />
            <ellipse
              cx="98.19"
              cy="65.87"
              rx="5.76"
              ry="1.13"
              fill="url(#fb82e76a-9219-4737-83bf-2576884788ec)"
            />
          </g>
        </g>
        <circle
          cx="98"
          cy="57"
          r="19"
          fill="url(#b05ab004-8ce9-4584-a01e-6b1d8adfaab6)"
        />
      </g>
      <g>
        <g>
          <rect
            x="407.16"
            y="13.53"
            width="1.27"
            height="22.47"
            rx="0.64"
            fill="#a39bb2"
          />
          <g>
            <ellipse
              cx="407.8"
              cy="7.57"
              rx="2.61"
              ry="0.51"
              fill="url(#f459655f-2d9a-4dd9-a75f-e6bb62aa8803)"
            />
            <ellipse
              cx="407.8"
              cy="8.46"
              rx="3.6"
              ry="0.67"
              fill="url(#be0663e3-fac5-4bb6-a39b-3d9a6a301c1c)"
            />
            <ellipse
              cx="407.8"
              cy="9.35"
              rx="4.59"
              ry="0.83"
              fill="url(#b3894309-af56-4386-883d-e2b612672bbc)"
            />
            <ellipse
              cx="407.8"
              cy="10.24"
              rx="5.57"
              ry="0.99"
              fill="url(#e890105f-f49d-4665-9cf9-3e8675ccea91)"
            />
            <ellipse
              cx="407.8"
              cy="11.13"
              rx="6.56"
              ry="1.15"
              fill="url(#f8db90fe-15b7-4ee4-968a-5015553b7b1d)"
            />
            <ellipse
              cx="407.8"
              cy="12.03"
              rx="7.55"
              ry="1.31"
              fill="url(#eb99e571-06ee-4732-a2a9-50c924e6a882)"
            />
            <ellipse
              cx="407.8"
              cy="13.34"
              rx="6.81"
              ry="1.2"
              fill="url(#a7de5b65-8914-4fbe-b135-2372e4fdb166)"
            />
            <ellipse
              cx="407.8"
              cy="14.65"
              rx="6.07"
              ry="1.09"
              fill="url(#e5467920-bc4b-4747-9eba-8e7e367e836a)"
            />
            <ellipse
              cx="407.8"
              cy="15.96"
              rx="5.32"
              ry="0.98"
              fill="url(#a451f3a7-a795-4377-841b-c1f11a6d1081)"
            />
            <ellipse
              cx="407.8"
              cy="17.27"
              rx="4.58"
              ry="0.86"
              fill="url(#a96fe636-1aa6-4b99-8bb0-0727234e2b26)"
            />
            <ellipse
              cx="407.8"
              cy="18.58"
              rx="3.84"
              ry="0.75"
              fill="url(#e2142895-2e21-4cc4-98a3-7ad6ebef33b6)"
            />
          </g>
        </g>
        <circle
          cx="407.67"
          cy="12.67"
          r="12.67"
          fill="url(#fff11dcd-58e1-4e60-b6ff-bdb7582e978e)"
        />
      </g>
      <g>
        <g>
          <rect
            x="18.24"
            y="88.29"
            width="1.91"
            height="33.71"
            rx="0.95"
            fill="#a39bb2"
          />
          <g>
            <ellipse
              cx="19.19"
              cy="79.36"
              rx="3.91"
              ry="0.77"
              fill="url(#fa396f17-1df6-4532-810a-e21cd5fa8d28)"
            />
            <ellipse
              cx="19.19"
              cy="80.7"
              rx="5.39"
              ry="1.01"
              fill="url(#b320cd29-9941-405c-90ca-1439e3b112ed)"
            />
            <ellipse
              cx="19.19"
              cy="82.03"
              rx="6.88"
              ry="1.25"
              fill="url(#e472634b-89c6-4181-81ba-0f1adc7c8924)"
            />
            <ellipse
              cx="19.19"
              cy="83.37"
              rx="8.36"
              ry="1.49"
              fill="url(#b3824da3-3697-4c96-ba3a-421f4489a908)"
            />
            <ellipse
              cx="19.19"
              cy="84.7"
              rx="9.84"
              ry="1.72"
              fill="url(#bb6d2292-171e-4f26-9bf1-83adfd212255)"
            />
            <ellipse
              cx="19.19"
              cy="86.04"
              rx="11.33"
              ry="1.96"
              fill="url(#fd1255f2-828d-4cfa-95a3-cd250b035c55)"
            />
            <ellipse
              cx="19.19"
              cy="88"
              rx="10.21"
              ry="1.8"
              fill="url(#bfb72319-14e1-4542-bed1-aec803dd7de7)"
            />
            <ellipse
              cx="19.19"
              cy="89.97"
              rx="9.1"
              ry="1.63"
              fill="url(#ae00f2f2-42fc-4d64-944f-35edcdcb8cdf)"
            />
            <ellipse
              cx="19.19"
              cy="91.94"
              rx="7.99"
              ry="1.46"
              fill="url(#bcd22b77-1c5c-4f4f-bf44-3230ef81bab6)"
            />
            <ellipse
              cx="19.19"
              cy="93.91"
              rx="6.87"
              ry="1.3"
              fill="url(#f988dff4-1c15-4e8d-aadb-805e09fa3333)"
            />
            <ellipse
              cx="19.19"
              cy="95.87"
              rx="5.76"
              ry="1.13"
              fill="url(#bcd59f11-29ca-46b3-816f-dc03b7e7e324)"
            />
          </g>
        </g>
        <circle
          cx="19"
          cy="87"
          r="19"
          fill="url(#ac444d1b-bebf-4db5-9cf0-11febd97d416)"
        />
      </g>
      <g>
        <g>
          <path
            d="M400,54s36-20,94,4l13.5-20.5S451,17,420,39Z"
            fill="#415c93"
          />
          <line
            x1="399.5"
            y1="31.5"
            x2="399.5"
            y2="53.5"
            fill="none"
            stroke="#adbcd8"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="3"
          />
          <line
            x1="448.5"
            y1="37.5"
            x2="448.5"
            y2="46.5"
            fill="none"
            stroke="#adbcd8"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="3"
          />
          <line
            x1="458.5"
            y1="19.5"
            x2="458.5"
            y2="28.5"
            fill="none"
            stroke="#adbcd8"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="3"
          />
          <line
            x1="496.5"
            y1="35.5"
            x2="496.5"
            y2="57.5"
            fill="none"
            stroke="#adbcd8"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="3"
          />
          <line
            x1="507.5"
            y1="15.5"
            x2="507.5"
            y2="37.5"
            fill="none"
            stroke="#adbcd8"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="3"
          />
          <line
            x1="419.5"
            y1="17.5"
            x2="419.5"
            y2="39.5"
            fill="none"
            stroke="#adbcd8"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="3"
          />
          <path
            d="M399.5,34.72s24,16.78,49-.22c0,0,15,15,48,5"
            fill="none"
            stroke="#adbcd8"
            strokeLinecap="round"
            strokeMiterlimit="10"
          />
          <path
            d="M420,20.38s15.51,13.91,38.51,1c0,0,36,16.77,49-3.56"
            fill="none"
            stroke="#adbcd8"
            strokeLinecap="round"
            strokeMiterlimit="10"
          />
        </g>
        <path
          d="M500.33,46s-36.46-17.27-86.65-2.88"
          fill="none"
          stroke="#dcceea"
          strokeMiterlimit="10"
          strokeDasharray="12"
        />
      </g>
      {/* <g>
        <path
          d="M610.56,60.71c1.8-3,2.41-3.64,1.65-5.64s-1.5-.29-.74-4A3.9,3.9,0,0,0,608,46c-1.32-.14-7.57,3.53-6.52,5.52s1.51,7.66.38,8.13S608.45,64.2,610.56,60.71Z"
          fill="#396039"
        />
        <path
          d="M609.36,53.81c-.06-1.61,2.38-2.26,1.59-3s-1.74-2.64-2.5-1.65-1.35,2.47-1.94,1.65-1.23-.85-1.61,0-.06,1.91-1,1.64-1.32.15-1.2,1,.79.53,1.38,1.58,3.23.91,2.79.33S609.36,53.81,609.36,53.81Z"
          fill="#447244"
        />
        <path
          d="M613.91,51c1.32-2.08,3.17-4,5-2.2s-1.23,5,0,6.25,1,4.47,0,4.58-5.58.12-6.78.68-2.76-1.5-2.79-3.49S613.91,51,613.91,51Z"
          fill="#6b996b"
        />
        <path
          d="M607,63.38c3.1,2.36,3.32-5.84,0-5.14s-4.4.5-5.46-1-3.69,1.11-3.78,1.84A4.74,4.74,0,0,0,600.29,63C602.11,63.73,605.11,62,607,63.38Z"
          fill="#447244"
        />
        <path
          d="M613.34,65c-3.09,2.36-3.31-5.84,0-5.13s4.41.5,5.46-1,3.7,1.11,3.79,1.85a4.72,4.72,0,0,1-2.58,3.9C618.19,65.38,615.19,63.62,613.34,65Z"
          fill="#447244"
        />
        <path
          d="M617.2,62.21c.44-.88,1.73.82,1.73.82s-.09-1.15.62-1.56,1,.65,1,.65c.06-.82,1.74-.06,1.27.92h0A3.92,3.92,0,0,1,620,64.67a3.28,3.28,0,0,1-1.31.17l-1.58-.4A3.79,3.79,0,0,1,617.2,62.21Z"
          fill="#396039"
        />
        <path
          d="M610.83,63.7c-.62,1.09-1,10.86,0,15.35,0,0-2.82-.49-3.7,0-.09.29-.09,0-.09,0s3.91-13.59.5-17.58-7.1,0-7.1,0,1-2.35,3.2-2.52,5.22,2.67,5.37,3.23c0,0,.12-4.29-1.26-5.79a1.61,1.61,0,0,1,.38-2.58s-1.82.56,1.11,4.38c1.53,2,.44,5.66.44,5.66s.94-2.88,3.29-2.26,3.76,3.35,6,3.17a11.63,11.63,0,0,1-4.64-1.38A2.72,2.72,0,0,0,610.83,63.7Z"
          fill="#704d3c"
        />
        <path
          d="M614,63.24a2.68,2.68,0,0,0-3.21.46,13.75,13.75,0,0,0-.5,3.65,7.13,7.13,0,0,1,1-5.58,2.18,2.18,0,0,1,1.68-.18,5.27,5.27,0,0,1,1.55.74Z"
          fill="#634b42"
        />
        <path
          d="M608.64,62.34a7.18,7.18,0,0,1,.28,4h0a8.07,8.07,0,0,0-1.38-4.86,7.33,7.33,0,0,0-.61-.63c-.08-.25-.14-.41-.14-.41A5.16,5.16,0,0,1,608.64,62.34Z"
          fill="#44322c"
        />
        <path
          d="M613.39,62.79c.85-.28.9-1.47,1.91-1.4s1.13,1.52,2,2.46,1.52.73,2.19,1.05-1.83,3.91-4.15,2.62-2.1-1.08-2.9-1.61A1.85,1.85,0,0,1,613.39,62.79Z"
          fill="#6b996b"
        />
        <g>
          <path d="M609,60.94c0,.06,0,.06,0,0v0Z" fill="#7f2c03" />
          <path
            d="M609,60.43c-.11-1.37-.4-3.17-1.2-4a1.77,1.77,0,0,1-.53-1.06l.41-.08a7.91,7.91,0,0,0,1.61,2.94l.07.09C609.24,59.05,609,59.84,609,60.43Z"
            fill="#634b42"
          />
        </g>
        <path
          d="M605.77,60.32c-.56-.7.06-1.72-.82-2.22s-1.78.64-3,1-1.68-.22-2.41-.32-.64,4.27,2,4.47,2.34.26,3.3.26A1.85,1.85,0,0,0,605.77,60.32Z"
          fill="#6b996b"
        />
        <path
          d="M606.89,52.08c.58-.91,1.39-1.74,2.2-1s-.54,2.18,0,2.73.42,2,0,2a16.57,16.57,0,0,0-3,.29c-.53.25-1.21-.65-1.22-1.52S606.89,52.08,606.89,52.08Z"
          fill="#6b996b"
        />
        <path
          d="M601.11,62.23c.17.26.66.21.94.09s.45-1,.9-.83.68.61,1.19.46.29-.69.94-.7,1.2.23,1.22.57v.08h0a.22.22,0,0,0,0,.08,1.65,1.65,0,0,1-1.42,1.49c-1,0-.65-.06-3.3-.26a2.18,2.18,0,0,1-1-.31C600.3,62.7,600.94,62,601.11,62.23Z"
          fill="#447244"
        />
        <path
          d="M613,65.9c.65,0,1.94.71,2.11.06s1.47-.79,1.62-.5a1.26,1.26,0,0,0,1.38.44c.44-.23.88.36.68.59-.82.92-2.2,1.77-3.52,1-1.61-.9-2-1.07-2.35-1.27C612.8,66.14,612.54,65.9,613,65.9Z"
          fill="#396039"
        />
        <path
          d="M610.62,58.48c.41-.91,1.41-.73,2.12-.62s.5,1.06,1,.62,1.79.62,1.33,1.38h0a10.87,10.87,0,0,0-3,.47c-.75.34-1.63-.31-2.19-1.34l-.25-.51h0S610.21,59.39,610.62,58.48Z"
          fill="#447244"
        />
        <path
          d="M618.08,57.92c-.27-.82.91-1.53,0-1.53s-2.41.91-2.26-.41-.27-2-1.26-1.93-1.76-2.06-1.21-2.54-3.11.92-1.49,2.3,2.2.94,2.14,1.59,0,2,1.23,2.2-.35,1.88.58,2.26S618.78,60.12,618.08,57.92Z"
          fill="#447244"
        />
        <path
          d="M607,79.05s.24-.84.56-2.17c2.45-1.25,2.62-5.35,2.63-5.47a41,41,0,0,0,.6,7.64s-2.82-.49-3.7,0C607,79.32,607,79.05,607,79.05Z"
          fill="#44322c"
        />
        <path
          d="M610,78.93a17.06,17.06,0,0,0-.36-2.33,15.5,15.5,0,0,1,0-2.36c.09-1.58.24-3.14.31-4.71a6.44,6.44,0,0,0-.1-2.32,3.88,3.88,0,0,1,0-2.36,4.82,4.82,0,0,1,1.33-1.95,3.13,3.13,0,0,1,2.31-.11,3.11,3.11,0,0,0-2.27.19,5,5,0,0,0-1.27,1.92,3.87,3.87,0,0,0,.08,2.28c0,.19.11.37.14.57a3.16,3.16,0,0,1,0,.61c0,.39,0,.79,0,1.18-.1,1.57-.26,3.14-.37,4.7a15.36,15.36,0,0,0,0,2.35A16.79,16.79,0,0,1,610,78.93Z"
          fill="#44322c"
        />
        <path
          d="M609.35,71.41a7.83,7.83,0,0,0,0,1,1.2,1.2,0,0,1-.32.92A2.62,2.62,0,0,0,608.3,75a3.89,3.89,0,0,0,.25,1.87,7.5,7.5,0,0,1,.22,1.94,10.94,10.94,0,0,0-.33-1.9,4,4,0,0,1-.31-1.93,2.72,2.72,0,0,1,.8-1.77C609.43,72.77,609.18,72,609.35,71.41Z"
          fill="#44322c"
        />
        <path
          d="M609.35,58.93c0,.38.17.72.2,1.11,0,.19-.08.39-.08.55a2.06,2.06,0,0,0,.1.53,5.35,5.35,0,0,1,.32,2.22c0,.39-.2.73-.24,1.09a5.76,5.76,0,0,0-.06,1.1,13.74,13.74,0,0,0,.26,2.21,9.22,9.22,0,0,1-.38-2.2,7.08,7.08,0,0,1,0-1.13c0-.38.19-.74.22-1.09a5.22,5.22,0,0,0-.27-2.17,2.61,2.61,0,0,1-.09-.57,4.18,4.18,0,0,0,.1-.54C609.47,59.68,609.35,59.31,609.35,58.93Z"
          fill="#44322c"
        />
      </g> */}
      <g>
        <path
          d="M580.56,31.71c1.8-3,2.41-3.64,1.65-5.64s-1.5-.29-.74-4.05A3.9,3.9,0,0,0,578,17c-1.32-.14-7.57,3.53-6.52,5.52s1.51,7.66.38,8.13S578.45,35.2,580.56,31.71Z"
          fill="#396039"
        />
        <path
          d="M579.36,24.81c-.06-1.61,2.38-2.26,1.59-3s-1.74-2.64-2.5-1.65-1.35,2.47-1.94,1.65-1.23-.85-1.61,0-.06,1.91-1,1.64-1.32.15-1.2,1,.79.53,1.38,1.58,3.23.91,2.79.33S579.36,24.81,579.36,24.81Z"
          fill="#447244"
        />
        <path
          d="M583.91,22c1.32-2.08,3.17-4,5-2.2s-1.23,5,0,6.25,1,4.47,0,4.58-5.58.12-6.78.68-2.76-1.5-2.79-3.49S583.91,22,583.91,22Z"
          fill="#6b996b"
        />
        <path
          d="M577,34.38c3.1,2.36,3.32-5.84,0-5.14s-4.4.5-5.46-1-3.69,1.11-3.78,1.84A4.74,4.74,0,0,0,570.29,34C572.11,34.73,575.11,33,577,34.38Z"
          fill="#447244"
        />
        <path
          d="M583.34,36c-3.09,2.36-3.31-5.84,0-5.13s4.41.5,5.46-1,3.7,1.11,3.79,1.85a4.72,4.72,0,0,1-2.58,3.9C588.19,36.38,585.19,34.62,583.34,36Z"
          fill="#447244"
        />
        <path
          d="M587.2,33.21c.44-.88,1.73.82,1.73.82s-.09-1.15.62-1.56,1,.65,1,.65c.06-.82,1.74-.06,1.27.92h0A3.92,3.92,0,0,1,590,35.67a3.28,3.28,0,0,1-1.31.17l-1.58-.4A3.79,3.79,0,0,1,587.2,33.21Z"
          fill="#396039"
        />
        <path
          d="M580.83,34.7c-.62,1.09-1,10.86,0,15.35,0,0-2.82-.49-3.7,0-.09.29-.09,0-.09,0s3.91-13.59.5-17.58-7.1,0-7.1,0,1-2.35,3.2-2.52,5.22,2.67,5.37,3.23c0,0,.12-4.29-1.26-5.79a1.61,1.61,0,0,1,.38-2.58s-1.82.56,1.11,4.38c1.53,2,.44,5.66.44,5.66s.94-2.88,3.29-2.26,3.76,3.35,6,3.17a11.63,11.63,0,0,1-4.64-1.38A2.72,2.72,0,0,0,580.83,34.7Z"
          fill="#704d3c"
        />
        <path
          d="M584,34.24a2.68,2.68,0,0,0-3.21.46,13.75,13.75,0,0,0-.5,3.65,7.13,7.13,0,0,1,1-5.58,2.18,2.18,0,0,1,1.68-.18,5.27,5.27,0,0,1,1.55.74Z"
          fill="#634b42"
        />
        <path
          d="M578.64,33.34a7.18,7.18,0,0,1,.28,4h0a8.07,8.07,0,0,0-1.38-4.86,7.33,7.33,0,0,0-.61-.63c-.08-.25-.14-.41-.14-.41A5.16,5.16,0,0,1,578.64,33.34Z"
          fill="#44322c"
        />
        <path
          d="M583.39,33.79c.85-.28.9-1.47,1.91-1.4s1.13,1.52,2,2.46,1.52.73,2.19,1-1.83,3.91-4.15,2.62-2.1-1.08-2.9-1.61A1.85,1.85,0,0,1,583.39,33.79Z"
          fill="#6b996b"
        />
        <g>
          <path d="M579,31.94c0,.06,0,.06,0,0v0Z" fill="#7f2c03" />
          <path
            d="M579,31.43c-.11-1.37-.4-3.17-1.2-4a1.77,1.77,0,0,1-.53-1.06l.41-.08a7.91,7.91,0,0,0,1.61,2.94l.07.09C579.24,30.05,579,30.84,579,31.43Z"
            fill="#634b42"
          />
        </g>
        <path
          d="M575.77,31.32c-.56-.7.06-1.72-.82-2.22s-1.78.64-3,1-1.68-.22-2.41-.32-.64,4.27,2,4.47,2.34.26,3.3.26A1.85,1.85,0,0,0,575.77,31.32Z"
          fill="#6b996b"
        />
        <path
          d="M576.89,23.08c.58-.91,1.39-1.74,2.2-1s-.54,2.18,0,2.73.42,2,0,2a16.57,16.57,0,0,0-3,.29c-.53.25-1.21-.65-1.22-1.52S576.89,23.08,576.89,23.08Z"
          fill="#6b996b"
        />
        <path
          d="M571.11,33.23c.17.26.66.21.94.09s.45-1,.9-.83.68.61,1.19.46.29-.69.94-.7,1.2.23,1.22.57v.08h0a.22.22,0,0,0,0,.08,1.65,1.65,0,0,1-1.42,1.49c-1,0-.65-.06-3.3-.26a2.18,2.18,0,0,1-1-.31C570.3,33.7,570.94,33,571.11,33.23Z"
          fill="#447244"
        />
        <path
          d="M583,36.9c.65,0,1.94.71,2.11.06s1.47-.79,1.62-.5a1.26,1.26,0,0,0,1.38.44c.44-.23.88.36.68.59-.82.92-2.2,1.77-3.52,1-1.61-.9-2-1.07-2.35-1.27C582.8,37.14,582.54,36.9,583,36.9Z"
          fill="#396039"
        />
        <path
          d="M580.62,29.48c.41-.91,1.41-.73,2.12-.62s.5,1.06,1,.62,1.79.62,1.33,1.38h0a10.87,10.87,0,0,0-3,.47c-.75.34-1.63-.31-2.19-1.34l-.25-.51h0S580.21,30.39,580.62,29.48Z"
          fill="#447244"
        />
        <path
          d="M588.08,28.92c-.27-.82.91-1.53,0-1.53s-2.41.91-2.26-.41-.27-2-1.26-1.93-1.76-2.06-1.21-2.54-3.11.92-1.49,2.3,2.2.94,2.14,1.59,0,2,1.23,2.2-.35,1.88.58,2.26S588.78,31.12,588.08,28.92Z"
          fill="#447244"
        />
        <path
          d="M577,50.05s.24-.84.56-2.17c2.45-1.25,2.62-5.35,2.63-5.47a41,41,0,0,0,.6,7.64s-2.82-.49-3.7,0C577,50.32,577,50.05,577,50.05Z"
          fill="#44322c"
        />
        <path
          d="M580,49.93a17.06,17.06,0,0,0-.36-2.33,15.5,15.5,0,0,1,0-2.36c.09-1.58.24-3.14.31-4.71a6.44,6.44,0,0,0-.1-2.32,3.88,3.88,0,0,1,0-2.36,4.82,4.82,0,0,1,1.33-2,3.13,3.13,0,0,1,2.31-.11,3.11,3.11,0,0,0-2.27.19,5,5,0,0,0-1.27,1.92,3.87,3.87,0,0,0,.08,2.28c0,.19.11.37.14.57a3.16,3.16,0,0,1,0,.61c0,.39,0,.79,0,1.18-.1,1.57-.26,3.14-.37,4.7a15.36,15.36,0,0,0,0,2.35A16.79,16.79,0,0,1,580,49.93Z"
          fill="#44322c"
        />
        <path
          d="M579.35,42.41a7.83,7.83,0,0,0,0,1,1.2,1.2,0,0,1-.32.92A2.62,2.62,0,0,0,578.3,46a3.89,3.89,0,0,0,.25,1.87,7.5,7.5,0,0,1,.22,1.94,10.94,10.94,0,0,0-.33-1.9,4,4,0,0,1-.31-1.93,2.72,2.72,0,0,1,.8-1.77C579.43,43.77,579.18,43,579.35,42.41Z"
          fill="#44322c"
        />
        <path
          d="M579.35,29.93c0,.38.17.72.2,1.11,0,.19-.08.39-.08.55a2.06,2.06,0,0,0,.1.53,5.35,5.35,0,0,1,.32,2.22c0,.39-.2.73-.24,1.09a5.76,5.76,0,0,0-.06,1.1,13.74,13.74,0,0,0,.26,2.21,9.22,9.22,0,0,1-.38-2.2,7.08,7.08,0,0,1,0-1.13c0-.38.19-.74.22-1.09a5.22,5.22,0,0,0-.27-2.17,2.61,2.61,0,0,1-.09-.57,4.18,4.18,0,0,0,.1-.54C579.47,30.68,579.35,30.31,579.35,29.93Z"
          fill="#44322c"
        />
      </g>
      <g>
        <g>
          <rect
            x="565.16"
            y="67.53"
            width="1.27"
            height="22.47"
            rx="0.64"
            fill="#a39bb2"
          />
          <g>
            <ellipse
              cx="565.8"
              cy="61.57"
              rx="2.61"
              ry="0.51"
              fill="url(#b243b76a-f6c7-48d2-a2b5-8b56eded842e)"
            />
            <ellipse
              cx="565.8"
              cy="62.46"
              rx="3.6"
              ry="0.67"
              fill="url(#f142f55d-12ba-4118-bd94-f89b6a32f7e2)"
            />
            <ellipse
              cx="565.8"
              cy="63.35"
              rx="4.59"
              ry="0.83"
              fill="url(#ae31a380-1e86-493a-acd4-c5f096a7f537)"
            />
            <ellipse
              cx="565.8"
              cy="64.24"
              rx="5.57"
              ry="0.99"
              fill="url(#b73f62c8-32a5-45fe-a7b0-7d34d40ba0a7)"
            />
            <ellipse
              cx="565.8"
              cy="65.13"
              rx="6.56"
              ry="1.15"
              fill="url(#b1d0ed6f-cc03-4984-9b17-4ba1a45f4cec)"
            />
            <ellipse
              cx="565.8"
              cy="66.03"
              rx="7.55"
              ry="1.31"
              fill="url(#ecfcb09a-e141-422f-bd0a-ae8d5ffcc317)"
            />
            <ellipse
              cx="565.8"
              cy="67.34"
              rx="6.81"
              ry="1.2"
              fill="url(#a5ec692b-8f0f-44d0-b709-dec42809c0fe)"
            />
            <ellipse
              cx="565.8"
              cy="68.65"
              rx="6.07"
              ry="1.09"
              fill="url(#f1abcf51-0840-464b-a19c-39983dbe140a)"
            />
            <ellipse
              cx="565.8"
              cy="69.96"
              rx="5.32"
              ry="0.98"
              fill="url(#af5eb6b5-7bd6-4225-b950-f61892d7d40f)"
            />
            <ellipse
              cx="565.8"
              cy="71.27"
              rx="4.58"
              ry="0.86"
              fill="url(#b5b23f0c-e8e2-4bec-95d1-9a7038103724)"
            />
            <ellipse
              cx="565.8"
              cy="72.58"
              rx="3.84"
              ry="0.75"
              fill="url(#fed4183e-8b8b-4d79-bbc6-6f45a9ed594e)"
            />
          </g>
        </g>
        <circle
          cx="565.67"
          cy="66.67"
          r="12.67"
          fill="url(#ab08811f-fd25-4455-ae98-5d2940b91aaa)"
        />
      </g>
      <g>
        <g>
          <rect
            x="591.16"
            y="33.53"
            width="1.27"
            height="22.47"
            rx="0.64"
            fill="#a39bb2"
          />
          <g>
            <ellipse
              cx="591.8"
              cy="27.57"
              rx="2.61"
              ry="0.51"
              fill="url(#f577a9e1-199e-4dc2-b078-3c89441bd094)"
            />
            <ellipse
              cx="591.8"
              cy="28.46"
              rx="3.6"
              ry="0.67"
              fill="url(#a3475e1b-3001-4d71-ba63-8a6a8a24e846)"
            />
            <ellipse
              cx="591.8"
              cy="29.35"
              rx="4.59"
              ry="0.83"
              fill="url(#bb53b05e-3826-404f-90da-0fcdf68d5d7b)"
            />
            <ellipse
              cx="591.8"
              cy="30.24"
              rx="5.57"
              ry="0.99"
              fill="url(#ae3e8ec6-5097-4f42-b45f-727db9361b58)"
            />
            <ellipse
              cx="591.8"
              cy="31.13"
              rx="6.56"
              ry="1.15"
              fill="url(#b827238b-be9c-454c-828b-64f1f84f69e5)"
            />
            <ellipse
              cx="591.8"
              cy="32.03"
              rx="7.55"
              ry="1.31"
              fill="url(#f65e846b-2545-4dce-8317-c0c6a1767b15)"
            />
            <ellipse
              cx="591.8"
              cy="33.34"
              rx="6.81"
              ry="1.2"
              fill="url(#a1f7457a-41e7-4cb9-a2aa-318455ebc7e3)"
            />
            <ellipse
              cx="591.8"
              cy="34.65"
              rx="6.07"
              ry="1.09"
              fill="url(#ebdb7a5c-ff4d-4017-b065-0933d7c65446)"
            />
            <ellipse
              cx="591.8"
              cy="35.96"
              rx="5.32"
              ry="0.98"
              fill="url(#f7582799-d9e8-400c-8ab8-53aa02f19823)"
            />
            <ellipse
              cx="591.8"
              cy="37.27"
              rx="4.58"
              ry="0.86"
              fill="url(#a958cca7-fe9c-4b76-a695-d85d8efaff7d)"
            />
            <ellipse
              cx="591.8"
              cy="38.58"
              rx="3.84"
              ry="0.75"
              fill="url(#b2d9e1a4-96d1-4fc9-b350-72b2044c484c)"
            />
          </g>
        </g>
        <circle
          cx="591.67"
          cy="32.67"
          r="12.67"
          fill="url(#b35272eb-dd59-41a1-af57-180f7a4ef154)"
        />
      </g>
      <g>
        <g>
          <rect
            x="876.44"
            y="60.8"
            width="3.91"
            height="69.2"
            rx="0.64"
            fill="#a39bb2"
          />
          <g>
            <ellipse
              cx="878.4"
              cy="42.47"
              rx="8.03"
              ry="1.58"
              fill="url(#a0b4b78b-b59e-4ab3-9407-4a3b04ee7acc)"
            />
            <ellipse
              cx="878.4"
              cy="45.22"
              rx="11.07"
              ry="2.07"
              fill="url(#b67a3ebd-4011-437b-9eea-7fd872f448b6)"
            />
            <ellipse
              cx="878.4"
              cy="47.96"
              rx="14.12"
              ry="2.56"
              fill="url(#af337c61-5d8c-4708-a95b-8aed2df6b5ab)"
            />
            <ellipse
              cx="878.4"
              cy="50.7"
              rx="17.16"
              ry="3.05"
              fill="url(#e9d0bd06-25fa-4361-9e66-fb6dccbd2d6f)"
            />
            <ellipse
              cx="878.4"
              cy="53.44"
              rx="20.2"
              ry="3.54"
              fill="url(#ad804521-10ed-483a-a60f-e7c11262501f)"
            />
            <ellipse
              cx="878.4"
              cy="56.18"
              rx="23.25"
              ry="4.03"
              fill="url(#a255bdbd-256f-4966-8f53-7eef964cd874)"
            />
            <ellipse
              cx="878.4"
              cy="60.22"
              rx="20.96"
              ry="3.69"
              fill="url(#add647cc-fb2f-475c-a110-ecd0a19f9be8)"
            />
            <ellipse
              cx="878.4"
              cy="64.26"
              rx="18.68"
              ry="3.35"
              fill="url(#a5df2b88-6415-4bdc-9785-75a52967b1fa)"
            />
            <ellipse
              cx="878.4"
              cy="68.29"
              rx="16.39"
              ry="3"
              fill="url(#e8aa6f05-e69e-4058-acff-46f3a46045bd)"
            />
            <ellipse
              cx="878.4"
              cy="72.33"
              rx="14.11"
              ry="2.66"
              fill="url(#ff2cf141-915f-4477-9556-a8792fbf07ea)"
            />
            <ellipse
              cx="878.4"
              cy="76.37"
              rx="11.82"
              ry="2.32"
              fill="url(#fb9c79e0-df4f-4d04-9d4d-eb5632df79ed)"
            />
          </g>
        </g>
        <circle
          cx="878"
          cy="58.16"
          r="39"
          fill="url(#a7b7019b-d50e-4a43-b901-de7c9217e05e)"
        />
      </g>
      <g>
        <path
          d="M490.21,208.22s12.71,26.37-3.36,40.78h24.93s-9.13-4.48-10.25-7.37-1.25-21.51-9.08-32.56Z"
          fill="#6d3b2f"
        />
        <path
          d="M493.41,209.51s1.34-15.22,10-17.2c0,0-3.62,3.09-1.81,5.6,0,0,3.31-7.47,13.39-5.6,0,0-11.62,1.42-13.39,8.45a8.13,8.13,0,0,1,8.91,2.71S493.4,203.76,493.41,209.51Z"
          fill="#43771c"
        />
        <path
          d="M490.21,209.51s-1.34-15.22-10-17.2c0,0,3.62,3.09,1.81,5.6,0,0-3.31-7.47-13.39-5.6,0,0,11.62,1.42,13.39,8.45a8.13,8.13,0,0,0-8.91,2.71S490.22,203.76,490.21,209.51Z"
          fill="#43771c"
        />
        <path
          d="M494.47,212.2s-16.82-21.91-35.59-13.48c0,0,10.62-.4,11.51.85,0,0-3.48-.55-3.31,2.88,0,0,7.22-3.46,9.25-1.75,0,0-4,.8-3.76,2.49,0,0,6.43-1.53,8.09,0,0,0-4.15,1-2.5,3,0,0,5.69-2.47,8.42,1.22,0,0-2.38-.81-3.11.07C483.47,207.41,494.05,210,494.47,212.2Z"
          fill="#529022"
        />
        <path
          d="M491.36,211.91s14.41-20.73,33.82-10.2c0,0-10.54-1.48-11.29-.29a3.31,3.31,0,0,1,3.56,3.28s-7.49-4.27-9.32-2.73c0,0,4,1.23,4,2.93,0,0-6.52-2.22-8-.86,0,0,4.2,1.42,2.77,3.29,0,0-5.87-3.1-8.2.4,0,0,2.27-.59,3.08.38C501.75,208.11,491.55,209.65,491.36,211.91Z"
          fill="#529022"
        />
        <path
          d="M494.85,211s-16-12.71-28.92,4.58c0,0,8-5.6,8.83-4.84a3.86,3.86,0,0,0-2.07,4.38s4.95-6.86,6.74-6.22c0,0-2.92,2.73-2.48,4.24,0,0,4.64-4.63,6.11-4,0,0-3,3-1.45,4.07,0,0,3.94-5.15,6.55-3,0,0-1.92.39-2.35,1.58C485.81,211.82,494.2,209.07,494.85,211Z"
          fill="#426642"
        />
        <path
          d="M490.21,211.44s19-14.62,33.87,4.57c0,0-9.25-6.13-10.27-5.27a4.16,4.16,0,0,1,2.35,4.89s-5.68-7.61-7.8-6.86c0,0,3.37,3,2.83,4.72,0,0-5.36-5.12-7.1-4.4,0,0,3.46,3.29,1.62,4.55,0,0-4.52-5.72-7.63-3.2,0,0,2.25.4,2.72,1.74C500.8,212.18,491,209.25,490.21,211.44Z"
          fill="#426642"
        />
        <path
          d="M493,211.9c-.69-8.8,8.59-19.05,15.27-18.41,0,0-13.19-2.56-15.32,5.34,0,0,2.67-10.47,6.56-10.47,0,0-8.59-2.35-10.14,4.91,0,0-4.64-9.07,0-10.3,0,0-10.62,2.83-6.09,9.88,0,0-4.85-4.06-10.62,1.28,0,0,11.32.21,13.24,4.7,0,0-5-3.21-7.9,0,0,0,10-1.66,12.49,5.71Z"
          fill="#529022"
        />
        <path
          d="M492.45,211.9c-.54-6.79,6.62-14.69,11.77-14.2,0,0-10.17-2-11.81,4.12,0,0,2-8.07,5.06-8.07,0,0-6.63-1.81-7.82,3.79,0,0-3.58-7,0-7.95,0,0-8.19,2.18-4.7,7.62,0,0-3.74-3.13-8.19,1,0,0,8.73.17,10.21,3.63,0,0-3.83-2.47-6.09,0,0,0,7.7-1.28,9.63,4.4Z"
          fill="#396039"
        />
        <path
          d="M491.59,214.58s.78-8.8,5.81-9.94c0,0-2.09,1.79-1,3.24,0,0,1.91-4.32,7.74-3.24,0,0-6.72.82-7.74,4.89a4.69,4.69,0,0,1,5.15,1.56S491.59,211.26,491.59,214.58Z"
          fill="#659965"
        />
        <path
          d="M493.1,213.3s-.78-8.8-5.81-9.94c0,0,2.09,1.79,1,3.24,0,0-1.91-4.32-7.74-3.24,0,0,6.72.82,7.74,4.89a4.69,4.69,0,0,0-5.15,1.56S493.1,210,493.1,213.3Z"
          fill="#659965"
        />
        <path
          d="M501.53,241.63c-1-2.59-1.21-17.95-7-29,.78,3.06,5.95,24,3.28,30-1.07,2.39,2.39,4.61,7.17,6.46h6.76S502.65,244.52,501.53,241.63Z"
          fill="#17216b"
          opacity="0.24"
        />
      </g>
      <g>
        <g>
          <rect
            x="867.44"
            y="201.8"
            width="3.91"
            height="69.2"
            rx="0.64"
            fill="#a39bb2"
          />
          <g>
            <ellipse
              cx="869.4"
              cy="183.47"
              rx="8.03"
              ry="1.58"
              fill="url(#a9b0dd84-6e46-4f94-b634-2ba9788bb17c)"
            />
            <ellipse
              cx="869.4"
              cy="186.22"
              rx="11.07"
              ry="2.07"
              fill="url(#e90b0f65-b6a5-4cdb-9472-aca300ffa460)"
            />
            <ellipse
              cx="869.4"
              cy="188.96"
              rx="14.12"
              ry="2.56"
              fill="url(#b568e9ce-eec1-4118-b7e0-07ba79ef7099)"
            />
            <ellipse
              cx="869.4"
              cy="191.7"
              rx="17.16"
              ry="3.05"
              fill="url(#a38e94fa-6742-4685-a522-df83c252e059)"
            />
            <ellipse
              cx="869.4"
              cy="194.44"
              rx="20.2"
              ry="3.54"
              fill="url(#a85ab821-b9ff-4f79-b62e-839c4bd22382)"
            />
            <ellipse
              cx="869.4"
              cy="197.18"
              rx="23.25"
              ry="4.03"
              fill="url(#e6ae38ee-67ec-4d50-a71d-bfa7465c07f7)"
            />
            <ellipse
              cx="869.4"
              cy="201.22"
              rx="20.96"
              ry="3.69"
              fill="url(#a55c0e41-873c-4e4d-97cb-c45c76c86216)"
            />
            <ellipse
              cx="869.4"
              cy="205.26"
              rx="18.68"
              ry="3.35"
              fill="url(#fa6af71d-8870-4b55-9cae-4cecc74a53bd)"
            />
            <ellipse
              cx="869.4"
              cy="209.29"
              rx="16.39"
              ry="3"
              fill="url(#a5bd624f-6b25-466c-908a-27a24465f0d3)"
            />
            <ellipse
              cx="869.4"
              cy="213.33"
              rx="14.11"
              ry="2.66"
              fill="url(#ba672f8f-ba66-44bb-908a-b42f85317b39)"
            />
            <ellipse
              cx="869.4"
              cy="217.37"
              rx="11.82"
              ry="2.32"
              fill="url(#e35e5631-e720-46d5-a441-91a225dd6e37)"
            />
          </g>
        </g>
        <circle
          cx="869"
          cy="199.16"
          r="39"
          fill="url(#b4b64e32-5db3-445c-a609-83f6f5e147e2)"
        />
      </g>
      <g>
        <path
          d="M634.21,389.22s12.71,26.37-3.36,40.78h24.93s-9.13-4.48-10.25-7.37-1.25-21.51-9.08-32.56Z"
          fill="#6d3b2f"
        />
        <path
          d="M637.41,390.51s1.34-15.22,10-17.2c0,0-3.62,3.09-1.81,5.6,0,0,3.31-7.47,13.39-5.6,0,0-11.62,1.42-13.39,8.45a8.13,8.13,0,0,1,8.91,2.71S637.4,384.76,637.41,390.51Z"
          fill="#43771c"
        />
        <path
          d="M634.21,390.51s-1.34-15.22-10-17.2c0,0,3.62,3.09,1.81,5.6,0,0-3.31-7.47-13.39-5.6,0,0,11.62,1.42,13.39,8.45a8.13,8.13,0,0,0-8.91,2.71S634.22,384.76,634.21,390.51Z"
          fill="#43771c"
        />
        <path
          d="M638.47,393.2s-16.82-21.91-35.59-13.48c0,0,10.62-.4,11.51.85,0,0-3.48-.55-3.31,2.88,0,0,7.22-3.46,9.25-1.75,0,0-4,.8-3.76,2.49,0,0,6.43-1.53,8.09,0,0,0-4.15,1-2.5,3,0,0,5.69-2.47,8.42,1.22,0,0-2.38-.81-3.11.07C627.47,388.41,638.05,391,638.47,393.2Z"
          fill="#529022"
        />
        <path
          d="M635.36,392.91s14.41-20.73,33.82-10.2c0,0-10.54-1.48-11.29-.29a3.31,3.31,0,0,1,3.56,3.28s-7.49-4.27-9.32-2.73c0,0,4,1.23,4,2.93,0,0-6.52-2.22-8-.86,0,0,4.2,1.42,2.77,3.29,0,0-5.87-3.1-8.2.4,0,0,2.27-.59,3.08.38C645.75,389.11,635.55,390.65,635.36,392.91Z"
          fill="#529022"
        />
        <path
          d="M638.85,392s-16-12.71-28.92,4.58c0,0,8-5.6,8.83-4.84a3.86,3.86,0,0,0-2.07,4.38s4.95-6.86,6.74-6.22c0,0-2.92,2.73-2.48,4.24,0,0,4.64-4.63,6.11-4,0,0-3,3-1.45,4.07,0,0,3.94-5.15,6.55-3,0,0-1.92.39-2.35,1.58C629.81,392.82,638.2,390.07,638.85,392Z"
          fill="#426642"
        />
        <path
          d="M634.21,392.44s19-14.62,33.87,4.57c0,0-9.25-6.13-10.27-5.27a4.16,4.16,0,0,1,2.35,4.89s-5.68-7.61-7.8-6.86c0,0,3.37,3,2.83,4.72,0,0-5.36-5.12-7.1-4.4,0,0,3.46,3.29,1.62,4.55,0,0-4.52-5.72-7.63-3.2,0,0,2.25.4,2.72,1.74C644.8,393.18,635,390.25,634.21,392.44Z"
          fill="#426642"
        />
        <path
          d="M637,392.9c-.69-8.8,8.59-19,15.27-18.41,0,0-13.19-2.56-15.32,5.34,0,0,2.67-10.47,6.56-10.47,0,0-8.59-2.35-10.14,4.91,0,0-4.64-9.07,0-10.3,0,0-10.62,2.83-6.09,9.88,0,0-4.85-4.06-10.62,1.28,0,0,11.32.21,13.24,4.7,0,0-5-3.21-7.9,0,0,0,10-1.66,12.49,5.71Z"
          fill="#529022"
        />
        <path
          d="M636.45,392.9c-.54-6.79,6.62-14.69,11.77-14.2,0,0-10.17-2-11.81,4.12,0,0,2.05-8.07,5.06-8.07,0,0-6.63-1.81-7.82,3.79,0,0-3.58-7,0-8,0,0-8.19,2.18-4.7,7.62,0,0-3.74-3.13-8.19,1,0,0,8.73.17,10.21,3.63,0,0-3.83-2.47-6.09,0,0,0,7.7-1.28,9.63,4.4Z"
          fill="#396039"
        />
        <path
          d="M635.59,395.58s.78-8.8,5.81-9.94c0,0-2.09,1.79-1,3.24,0,0,1.91-4.32,7.74-3.24,0,0-6.72.82-7.74,4.89a4.69,4.69,0,0,1,5.15,1.56S635.59,392.26,635.59,395.58Z"
          fill="#659965"
        />
        <path
          d="M637.1,394.3s-.78-8.8-5.81-9.94c0,0,2.09,1.79,1.05,3.24,0,0-1.91-4.32-7.74-3.24,0,0,6.72.82,7.74,4.89a4.69,4.69,0,0,0-5.15,1.56S637.1,391,637.1,394.3Z"
          fill="#659965"
        />
        <path
          d="M645.53,422.63c-1-2.59-1.21-17.95-7-29.05.78,3.06,5.95,24,3.28,30-1.07,2.39,2.39,4.61,7.17,6.46h6.76S646.65,425.52,645.53,422.63Z"
          fill="#17216b"
          opacity="0.24"
        />
      </g>
      <g>
        <path
          d="M682.84,377.22s-12.7,26.37,3.37,40.78H661.28s9.13-4.48,10.25-7.37,1.24-21.51,9.08-32.56Z"
          fill="#6d3b2f"
        />
        <path
          d="M679.65,378.51s-1.34-15.22-10-17.2c0,0,3.61,3.09,1.8,5.6,0,0-3.3-7.47-13.39-5.6,0,0,11.63,1.42,13.39,8.45a8.11,8.11,0,0,0-8.9,2.71S679.66,372.76,679.65,378.51Z"
          fill="#43771c"
        />
        <path
          d="M682.84,378.51s1.35-15.22,10-17.2c0,0-3.62,3.09-1.81,5.6,0,0,3.3-7.47,13.39-5.6,0,0-11.63,1.42-13.39,8.45a8.13,8.13,0,0,1,8.91,2.71S682.83,372.76,682.84,378.51Z"
          fill="#43771c"
        />
        <path
          d="M678.58,381.2s16.83-21.91,35.6-13.48c0,0-10.62-.4-11.51.85,0,0,3.48-.55,3.3,2.88,0,0-7.21-3.46-9.25-1.75,0,0,4,.8,3.77,2.49,0,0-6.43-1.53-8.09,0,0,0,4.15,1,2.49,3,0,0-5.68-2.47-8.41,1.22,0,0,2.38-.81,3.11.07C689.59,376.41,679,379,678.58,381.2Z"
          fill="#529022"
        />
        <path
          d="M681.7,380.91s-14.41-20.73-33.82-10.2c0,0,10.53-1.48,11.29-.29a3.31,3.31,0,0,0-3.56,3.28s7.49-4.27,9.32-2.73c0,0-4,1.23-4,2.93,0,0,6.51-2.22,8-.86,0,0-4.2,1.42-2.77,3.29,0,0,5.87-3.1,8.19.4,0,0-2.26-.59-3.08.38C671.3,377.11,681.5,378.65,681.7,380.91Z"
          fill="#529022"
        />
        <path
          d="M678.2,380s16-12.71,28.93,4.58c0,0-8-5.6-8.83-4.84a3.86,3.86,0,0,1,2.07,4.38s-5-6.86-6.74-6.22c0,0,2.91,2.73,2.48,4.24,0,0-4.64-4.63-6.12-4,0,0,3,3,1.46,4.07,0,0-3.94-5.15-6.55-3,0,0,1.91.39,2.34,1.58C687.24,380.82,678.86,378.07,678.2,380Z"
          fill="#426642"
        />
        <path
          d="M682.85,380.44s-19-14.62-33.88,4.57c0,0,9.26-6.13,10.28-5.27a4.16,4.16,0,0,0-2.35,4.89s5.68-7.61,7.79-6.86c0,0-3.36,3-2.83,4.72,0,0,5.36-5.12,7.11-4.4,0,0-3.47,3.29-1.63,4.55,0,0,4.53-5.72,7.63-3.2,0,0-2.24.4-2.72,1.74C672.25,381.18,682,378.25,682.85,380.44Z"
          fill="#426642"
        />
        <path
          d="M680.07,380.9c.69-8.8-8.6-19-15.27-18.41,0,0,13.19-2.56,15.32,5.34,0,0-2.67-10.47-6.57-10.47,0,0,8.6-2.35,10.15,4.91,0,0,4.64-9.07,0-10.3,0,0,10.62,2.83,6.08,9.88,0,0,4.86-4.06,10.62,1.28,0,0-11.31.21-13.23,4.7,0,0,5-3.21,7.9,0,0,0-10-1.66-12.49,5.71Z"
          fill="#529022"
        />
        <path
          d="M680.61,380.9c.53-6.79-6.63-14.69-11.77-14.2,0,0,10.16-2,11.81,4.12,0,0-2.06-8.07-5.06-8.07,0,0,6.63-1.81,7.82,3.79,0,0,3.58-7,0-8,0,0,8.19,2.18,4.69,7.62,0,0,3.75-3.13,8.19,1,0,0-8.72.17-10.21,3.63,0,0,3.83-2.47,6.1,0,0,0-7.7-1.28-9.64,4.4Z"
          fill="#396039"
        />
        <path
          d="M681.46,383.58s-.77-8.8-5.8-9.94c0,0,2.09,1.79,1,3.24,0,0-1.9-4.32-7.74-3.24,0,0,6.72.82,7.74,4.89a4.68,4.68,0,0,0-5.14,1.56S681.47,380.26,681.46,383.58Z"
          fill="#659965"
        />
        <path
          d="M680,382.3s.78-8.8,5.81-9.94c0,0-2.1,1.79-1,3.24,0,0,1.91-4.32,7.74-3.24,0,0-6.72.82-7.74,4.89a4.69,4.69,0,0,1,5.15,1.56S680,379,680,382.3Z"
          fill="#659965"
        />
        <path
          d="M671.53,410.63c1-2.59,1.21-17.95,7-29.05-.78,3.06-6,24-3.28,30,1.07,2.39-2.39,4.61-7.18,6.46h-6.75S670.41,413.52,671.53,410.63Z"
          fill="#17216b"
          opacity="0.24"
        />
      </g>
      <ellipse
        cx="901.5"
        cy="338.5"
        rx="11.5"
        ry="4.5"
        fill="#141c66"
        opacity="0.28"
      />
      <g>
        <path d="M884.49,324.3v0h0Z" fill="#ef6291" />
        <path
          d="M911.61,318.78v0c0,1.53-6.42,2.75-13.79,2.75s-13.33-1.24-13.33-2.77Z"
          fill="#ef6291"
        />
        <path
          d="M906.18,335.8h0a.22.22,0,0,1,0,.08c0,.9-3.51,1.63-7.85,1.63s-7.84-.73-7.84-1.63a.22.22,0,0,1,0-.08h-.08l-5.9-11.58h27.12Z"
          fill="#c1567f"
        />
        <path
          d="M911.61,318.8c0,1.53-6.42,2.75-13.79,2.75s-13.33-1.24-13.33-2.77,6-2.77,13.33-2.77,13.73,1.25,13.79,2.77Z"
          fill="#c16f86"
        />
        <path
          d="M910.08,318.8c0,1.35-5.69,2.44-12.23,2.44S886,320.14,886,318.78s5.3-2.46,11.84-2.46S910.08,317.44,910.08,318.8Z"
          fill="#513126"
        />
        <path
          d="M906,336.22c-9.41.46-9.1-11.1-9.1-11.1l-12.15-.43,5.66,11.11h.08a.22.22,0,0,0,0,.08c0,.9,3.51,1.63,7.84,1.63C902.09,337.51,905.24,337,906,336.22Z"
          fill="#602b8e"
          opacity="0.35"
        />
        <path
          d="M911.61,318.8v5.52c-.05,1.52-6.21,2.77-13.54,2.77s-13.53-1.25-13.58-2.77v-5.54c0,1.53,6,2.77,13.33,2.77S911.61,320.33,911.61,318.8Z"
          fill="#ef6291"
        />
        <path
          d="M891.67,321.24h0c-4.27-.46-7.18-1.38-7.18-2.45v5.54c0,1.3,4.58,2.4,10.5,2.69C890.59,326,891.67,321.24,891.67,321.24Z"
          fill="#602b8e"
          opacity="0.35"
        />
        <g>
          <path
            d="M888.63,316.18c-2.16.42-4.16-4.58-5.59-6.84,0,0,3.77.23,5.63,1.43S891.55,315.6,888.63,316.18Z"
            fill="#1c7f19"
          />
          <path
            d="M883,309.34a35.75,35.75,0,0,1,3.88,2.69,17.55,17.55,0,0,1,1.74,1.6,3.56,3.56,0,0,1,1.14,2,2.16,2.16,0,0,0-.46-1.06,7.15,7.15,0,0,0-.76-.89,19.9,19.9,0,0,0-1.76-1.55C885.61,311.15,884.32,310.26,883,309.34Z"
            fill="#30562e"
          />
        </g>
        <g>
          <path
            d="M901.42,314c-2.16.42-4.16-4.58-5.59-6.83,0,0,3.78.23,5.64,1.43S904.34,313.39,901.42,314Z"
            fill="#1c7f19"
          />
          <path
            d="M895.83,307.13a35.35,35.35,0,0,1,3.89,2.68,20.35,20.35,0,0,1,1.74,1.61,3.49,3.49,0,0,1,1.13,2,2,2,0,0,0-.46-1.06,7.07,7.07,0,0,0-.75-.89,20,20,0,0,0-1.77-1.55C898.41,308.93,897.11,308,895.83,307.13Z"
            fill="#30562e"
          />
        </g>
        <g>
          <path
            d="M896.19,320.77c-2.16.42-4.16-4.57-5.59-6.83,0,0,3.78.23,5.63,1.43S899.11,320.2,896.19,320.77Z"
            fill="#1b6817"
          />
          <path
            d="M890.6,313.94a36.79,36.79,0,0,1,3.89,2.68,18.84,18.84,0,0,1,1.73,1.61,3.48,3.48,0,0,1,1.14,2,2,2,0,0,0-.46-1.05,5.86,5.86,0,0,0-.76-.89,17.36,17.36,0,0,0-1.76-1.56C893.18,315.74,891.88,314.85,890.6,313.94Z"
            fill="#30562e"
          />
        </g>
        <g>
          <path
            d="M890.54,320.77c-1.55.3-3-3.29-4-4.91a10.7,10.7,0,0,1,4.05,1C891.91,317.74,892.64,320.36,890.54,320.77Z"
            fill="#1b6817"
          />
          <path
            d="M886.52,315.86a26.67,26.67,0,0,1,2.8,1.92,13.61,13.61,0,0,1,1.24,1.16,2.51,2.51,0,0,1,.82,1.45,2.73,2.73,0,0,0-.87-1.4,14.84,14.84,0,0,0-1.27-1.11C888.37,317.15,887.44,316.51,886.52,315.86Z"
            fill="#30562e"
          />
        </g>
        <g>
          <path
            d="M890.3,310.5c-1.57.31-3-3.33-4.06-5a10.89,10.89,0,0,1,4.09,1C891.68,307.44,892.42,310.08,890.3,310.5Z"
            fill="#1c7f19"
          />
          <path
            d="M886.24,305.53a26.17,26.17,0,0,1,2.82,2,14,14,0,0,1,1.26,1.17,2.55,2.55,0,0,1,.83,1.47,2.8,2.8,0,0,0-.89-1.41,11.49,11.49,0,0,0-1.28-1.13C888.11,306.85,887.17,306.2,886.24,305.53Z"
            fill="#30562e"
          />
        </g>
        <g>
          <path
            d="M892.07,318.06c2.16.43,4.17-4.57,5.6-6.83,0,0-3.78.23-5.64,1.43S889.16,317.49,892.07,318.06Z"
            fill="#1c7f19"
          />
          <path
            d="M897.67,311.23c-1.28.91-2.58,1.81-3.78,2.81a17.48,17.48,0,0,0-1.77,1.56,5.8,5.8,0,0,0-.75.89,2,2,0,0,0-.47,1.06,3.53,3.53,0,0,1,1.14-2,20.35,20.35,0,0,1,1.74-1.61A36.79,36.79,0,0,1,897.67,311.23Z"
            fill="#30562e"
          />
        </g>
        <g>
          <path
            d="M903.26,311.42c2.16.42,4.16-4.58,5.59-6.84,0,0-3.77.23-5.63,1.43S900.34,310.84,903.26,311.42Z"
            fill="#1c7f19"
          />
          <path
            d="M908.85,304.58c-1.28.92-2.57,1.81-3.78,2.82a19.9,19.9,0,0,0-1.76,1.55,7.15,7.15,0,0,0-.76.89,2.16,2.16,0,0,0-.46,1.06,3.56,3.56,0,0,1,1.14-2,17.55,17.55,0,0,1,1.74-1.6A35.75,35.75,0,0,1,908.85,304.58Z"
            fill="#30562e"
          />
        </g>
        <g>
          <path
            d="M892.09,312.39c1.57.3,3-3.33,4.07-5a10.92,10.92,0,0,0-4.1,1C890.71,309.33,890,312,892.09,312.39Z"
            fill="#1b6817"
          />
          <path
            d="M896.16,307.42c-.94.67-1.88,1.31-2.75,2.05a11.49,11.49,0,0,0-1.28,1.13,2.8,2.8,0,0,0-.89,1.41,2.57,2.57,0,0,1,.83-1.47,14,14,0,0,1,1.26-1.17A27.33,27.33,0,0,1,896.16,307.42Z"
            fill="#30562e"
          />
        </g>
        <path
          d="M891.93,320.15a9,9,0,0,1-1.64-3,5.23,5.23,0,0,1-.24-1.77,3.62,3.62,0,0,1,.16-.92l.3-.81a13.39,13.39,0,0,0,.54-3.26c.06-1.13.09-2.26.08-3.41a16.34,16.34,0,0,1,.43,3.42,10.61,10.61,0,0,1-.44,3.47,4.58,4.58,0,0,0-.45,1.55,5.19,5.19,0,0,0,.11,1.61A13.34,13.34,0,0,0,891.93,320.15Z"
          fill="#30562e"
        />
        <path
          d="M898.05,310.14c-.1.41-.35.84-.46,1.19a3.88,3.88,0,0,0,.37,1.11,9.39,9.39,0,0,1,.72,2.54,11.59,11.59,0,0,1-.63,5.17c.05-.86.08-1.72.1-2.57a19.08,19.08,0,0,0-.12-2.52,13,13,0,0,0-.55-2.46c-.05-.21-.12-.41-.17-.63a1.3,1.3,0,0,1,0-.74C897.55,310.8,897.8,310.52,898.05,310.14Z"
          fill="#30562e"
        />
        <path
          d="M903.36,305.63a7,7,0,0,1-1,1.49c-.38.45-.74.92-.59,1.4a3.64,3.64,0,0,0,.86,1.39,5.4,5.4,0,0,1,.93,1.65,9.92,9.92,0,0,1,.44,3.65,13.84,13.84,0,0,1-.61,3.57,32.91,32.91,0,0,0,.11-3.57,12.13,12.13,0,0,0-.55-3.43,4.8,4.8,0,0,0-.79-1.48,3.75,3.75,0,0,1-.89-1.7,1.38,1.38,0,0,1,.23-1,3.85,3.85,0,0,1,.64-.69A9.38,9.38,0,0,0,903.36,305.63Z"
          fill="#30562e"
        />
        <g>
          <path
            d="M904.47,317.64c1.57.31,3-3.33,4.06-5a10.89,10.89,0,0,0-4.09,1C903.09,314.58,902.35,317.23,904.47,317.64Z"
            fill="#1b6817"
          />
          <path
            d="M903,320c1.57.31,3-3.33,4.06-5a10.8,10.8,0,0,0-4.09,1C901.64,317,900.9,319.61,903,320Z"
            fill="#1b6817"
          />
          <path
            d="M908.53,312.67c-.93.67-1.87,1.32-2.75,2.05a13.61,13.61,0,0,0-1.28,1.13,2.78,2.78,0,0,0-.88,1.41,2.55,2.55,0,0,1,.83-1.47,14,14,0,0,1,1.26-1.17A26.17,26.17,0,0,1,908.53,312.67Z"
            fill="#30562e"
          />
        </g>
        <g>
          <path
            d="M899.56,319.7c2.16.43,4.16-4.57,5.59-6.83,0,0-3.78.23-5.63,1.43S896.64,319.13,899.56,319.7Z"
            fill="#1c7f19"
          />
          <path
            d="M905.15,312.87c-1.28.92-2.58,1.81-3.78,2.82a17.27,17.27,0,0,0-1.76,1.55,5.86,5.86,0,0,0-.76.89,2.07,2.07,0,0,0-.46,1.06,3.47,3.47,0,0,1,1.14-2,16.5,16.5,0,0,1,1.74-1.6A35.75,35.75,0,0,1,905.15,312.87Z"
            fill="#30562e"
          />
        </g>
        <g>
          <path
            d="M896.74,313c-1.57.31-3-3.32-4.06-5a10.89,10.89,0,0,1,4.09,1C898.12,310,898.86,312.63,896.74,313Z"
            fill="#1c7f19"
          />
          <path
            d="M892.68,308.08A28.31,28.31,0,0,1,895.5,310a12.65,12.65,0,0,1,1.26,1.17,2.49,2.49,0,0,1,.83,1.47,2.78,2.78,0,0,0-.89-1.42,12.6,12.6,0,0,0-1.28-1.13C894.55,309.39,893.61,308.74,892.68,308.08Z"
            fill="#30562e"
          />
        </g>
        <g>
          <path
            d="M903.45,308c-1.72-.65-.26-3.4-.46-4.55s1.52-1.9,2.89-1.23.57,1.85,1.68,2.55S904.84,308.54,903.45,308Z"
            fill="#bc784a"
          />
          <path
            d="M902.7,308.16c-1.82-.2-1.08-3.23-1.55-4.29s1-2.23,2.49-1.92,1,1.64,2.26,2S904.17,308.31,902.7,308.16Z"
            fill="#ed863a"
          />
          <path
            d="M902.61,308.4c-1.82-.2-.23-2.73-.7-3.79s.08-2,1.57-1.73.94.87,2.19,1.27S904.09,308.55,902.61,308.4Z"
            fill="#bc784a"
          />
          <path
            d="M902.86,308.91c-1.62-.48-.44-2.81-.69-3.76s1.29-1.62,2.58-1.1.64,1.51,1.71,2.05S904.17,309.3,902.86,308.91Z"
            fill="#ed863a"
          />
        </g>
        <g>
          <path
            d="M897.69,308.93c-1.8-.33-.83-3.3-1.22-4.4s1.17-2.13,2.63-1.71.88,1.71,2.1,2.21S899.15,309.21,897.69,308.93Z"
            fill="#bc784a"
          />
          <path
            d="M897,309.2c-1.83.13-1.61-3-2.25-3.95s.61-2.37,2.13-2.33,1.27,1.44,2.57,1.61S898.45,309.1,897,309.2Z"
            fill="#ed863a"
          />
          <path
            d="M896.93,309.45c-1.82.13-.69-2.64-1.34-3.6s-.26-2,1.26-2,1.07.69,2.37.86S898.42,309.35,896.93,309.45Z"
            fill="#bc784a"
          />
          <path
            d="M897.26,309.92c-1.68-.19-.91-2.7-1.31-3.58s1-1.83,2.35-1.55.88,1.38,2,1.73S898.62,310.07,897.26,309.92Z"
            fill="#ed863a"
          />
        </g>
        <g>
          <path
            d="M892.21,307.21c1.8-.34.82-3.31,1.21-4.4s-1.17-2.14-2.63-1.71-.88,1.71-2.09,2.21S890.74,307.48,892.21,307.21Z"
            fill="#bc784a"
          />
          <path
            d="M892.92,307.48c1.83.13,1.61-3,2.25-4s-.61-2.37-2.13-2.33-1.26,1.44-2.57,1.61S891.44,307.37,892.92,307.48Z"
            fill="#ed863a"
          />
          <path
            d="M893,307.73c1.83.13.7-2.64,1.34-3.6s.26-2-1.26-2-1.07.7-2.37.87S891.48,307.62,893,307.73Z"
            fill="#bc784a"
          />
          <path
            d="M892.64,308.19c1.67-.19.9-2.69,1.31-3.58s-1-1.82-2.36-1.54-.88,1.37-2,1.72S891.28,308.35,892.64,308.19Z"
            fill="#ed863a"
          />
        </g>
        <ellipse
          cx="905.33"
          cy="316.3"
          rx="1.15"
          ry="0.35"
          transform="translate(81.77 807.65) rotate(-50.08)"
          fill="#b2eff9"
          opacity="0.25"
        />
      </g>
      <g>
        <path
          d="M607.86,490.6s-20.69,24.45-54.48,14.07c0,0-8.49.66-1.26-14.11s15.16-5.75,15.16-5.75-.93-12.15,10.51-11.25,4.32,11.21,8.61,12.49,5.25-10,10-11.95,13.47,3,12.48,9.73Z"
          fill="#396039"
        />
        <path
          d="M580.54,497.82c-4.62,0,.21-6.22-1.7-7.76s-5.13,4-7.75,7.08-5.41,0-8.81-4-4.78-7.13-10.16-2.58-13.3,10.88-6.37,14,17.83,6,22,2.6,10.89,3.3,12.65.94S584.54,497.84,580.54,497.82Z"
          fill="#426642"
        />
        <path
          d="M577,484.05c3.15-3.09.4-8.17-3.1-6.6s-.78,7.09-4,8.79-8.81,3.67-2.55,5.61S577,484.05,577,484.05Z"
          fill="#2f4f2f"
        />
        <path
          d="M598.7,493.89c4.61-2.87,5.5-7.88,4.08-9s-5.31-4.44-6.45,0-8.71,5.75-7.09,9.87S598.7,493.89,598.7,493.89Z"
          fill="#2f4f2f"
        />
        <path
          d="M595,504.38c5.76-5.21,10.14-3.52,9.74-6.86s.52-6.53-3.28-7.35-4.15,3.75-7.46,4.51-3.86-4.91-7-.7S588.18,510.54,595,504.38Z"
          fill="#426642"
        />
        <path
          d="M585.88,507.92c6.49-2,4.37-5,2.31-6.62s-6,2.9-8.62,1.72-7.9,3.19-10.44,1.13-7.74-6-10.27-1.95-6.52,12.83,1.19,8.88,15.77-1,19.48-1.08A12.23,12.23,0,0,0,585.88,507.92Z"
          fill="#659965"
        />
      </g>
      <g>
        <path
          d="M984.45,507.07l-2.24-.85A56.3,56.3,0,0,1,986.65,522h3.94C989.37,516.79,987.49,511.36,984.45,507.07Z"
          fill="#6d3b2f"
        />
        <path
          d="M985.41,507.51s1.34-15.22,10-17.2c0,0-3.62,3.09-1.81,5.6,0,0,3.31-7.47,13.39-5.6,0,0-11.62,1.42-13.39,8.45a8.13,8.13,0,0,1,8.91,2.71S985.4,501.76,985.41,507.51Z"
          fill="#43771c"
        />
        <path
          d="M982.21,507.51s-1.34-15.22-10-17.2c0,0,3.62,3.09,1.81,5.6,0,0-3.31-7.47-13.39-5.6,0,0,11.62,1.42,13.39,8.45a8.13,8.13,0,0,0-8.91,2.71S982.22,501.76,982.21,507.51Z"
          fill="#43771c"
        />
        <path
          d="M986.47,510.2s-16.82-21.91-35.59-13.48c0,0,10.62-.4,11.51.85,0,0-3.48-.55-3.31,2.88,0,0,7.22-3.46,9.25-1.75,0,0-4,.8-3.76,2.49,0,0,6.43-1.53,8.09,0,0,0-4.15,1-2.5,3,0,0,5.69-2.47,8.42,1.22,0,0-2.38-.81-3.11.07C975.47,505.41,986.05,508,986.47,510.2Z"
          fill="#529022"
        />
        <path
          d="M983.36,509.91s14.41-20.73,33.82-10.2c0,0-10.54-1.48-11.29-.29a3.31,3.31,0,0,1,3.56,3.28s-7.49-4.27-9.32-2.73c0,0,4,1.23,4,2.93,0,0-6.52-2.22-8-.86,0,0,4.2,1.42,2.77,3.29,0,0-5.87-3.1-8.2.4,0,0,2.27-.59,3.08.38C993.75,506.11,983.55,507.65,983.36,509.91Z"
          fill="#529022"
        />
        <path
          d="M986.85,509s-16-12.71-28.92,4.58c0,0,8-5.6,8.83-4.84a3.86,3.86,0,0,0-2.07,4.38s4.95-6.86,6.74-6.22c0,0-2.92,2.73-2.48,4.24,0,0,4.64-4.63,6.11-4,0,0-3,3-1.45,4.07,0,0,3.94-5.15,6.55-3,0,0-1.92.39-2.35,1.58C977.81,509.82,986.2,507.07,986.85,509Z"
          fill="#426642"
        />
        <path
          d="M982.21,509.44s19-14.62,33.87,4.57c0,0-9.25-6.13-10.27-5.27a4.16,4.16,0,0,1,2.35,4.89s-5.68-7.61-7.8-6.86c0,0,3.37,3,2.83,4.72,0,0-5.36-5.12-7.1-4.4,0,0,3.46,3.29,1.62,4.55,0,0-4.52-5.72-7.63-3.2,0,0,2.25.4,2.72,1.74C992.8,510.18,983,507.25,982.21,509.44Z"
          fill="#426642"
        />
        <path
          d="M985,509.9c-.69-8.8,8.59-19,15.27-18.41,0,0-13.19-2.56-15.32,5.34,0,0,2.67-10.47,6.56-10.47,0,0-8.59-2.35-10.14,4.91,0,0-4.64-9.07,0-10.3,0,0-10.62,2.83-6.09,9.88,0,0-4.85-4.06-10.62,1.28,0,0,11.32.21,13.24,4.7,0,0-5-3.21-7.9,0,0,0,10-1.66,12.49,5.71Z"
          fill="#529022"
        />
        <path
          d="M984.45,509.9c-.54-6.79,6.62-14.69,11.77-14.2,0,0-10.17-2-11.81,4.12,0,0,2.05-8.07,5.06-8.07,0,0-6.63-1.81-7.82,3.79,0,0-3.58-7,0-8,0,0-8.19,2.18-4.7,7.62,0,0-3.74-3.13-8.19,1,0,0,8.73.17,10.21,3.63,0,0-3.83-2.47-6.09,0,0,0,7.7-1.28,9.63,4.4Z"
          fill="#396039"
        />
        <path
          d="M983.59,512.58s.78-8.8,5.81-9.94c0,0-2.09,1.79-1,3.24,0,0,1.91-4.32,7.74-3.24,0,0-6.72.82-7.74,4.89a4.69,4.69,0,0,1,5.15,1.56S983.59,509.26,983.59,512.58Z"
          fill="#659965"
        />
        <path
          d="M985.1,511.3s-.78-8.8-5.81-9.94c0,0,2.09,1.79,1.05,3.24,0,0-1.91-4.32-7.74-3.24,0,0,6.72.82,7.74,4.89a4.69,4.69,0,0,0-5.15,1.56S985.1,508,985.1,511.3Z"
          fill="#659965"
        />
        <path
          d="M986.57,510.58c.34,1.33,1.5,6,2.5,11.42h1.52A50,50,0,0,0,986.57,510.58Z"
          fill="#17216b"
          opacity="0.24"
        />
      </g>
      <g>
        <g>
          <path
            d="M1040.2,444.91c-.07-.53-.11-1.07-.14-1.59a12.94,12.94,0,0,1,.07-2.33c.1-.69.3-1.36.46-2a6.6,6.6,0,0,0,.2-1.82c0-.67-.22-1.31-.27-2a4.51,4.51,0,0,1,.14-1.51c.13-.34.26-.68.42-1a8.35,8.35,0,0,1,.58-.88.14.14,0,0,0,0-.18,7.07,7.07,0,0,1,7.88-3.4,2,2,0,0,0,.54.55,4.71,4.71,0,0,0,1.63.6,3.15,3.15,0,0,1,1.69.88,15.57,15.57,0,0,1,1.14,1.83,3.39,3.39,0,0,0,.76.8,3.6,3.6,0,0,0,.93.44,2.55,2.55,0,0,1,1,.6,8.19,8.19,0,0,1,.66.89,7.55,7.55,0,0,0,.79.81,6,6,0,0,1,.57.66c.83,1.1.9,2.57,1.21,3.87a5.62,5.62,0,0,0,.91,2.15,10.28,10.28,0,0,0,1.36,1.36,4.51,4.51,0,0,1,1,1.19,5,5,0,0,1,.46,2.16c.09,1.78-.06,3.56.15,5.33a10.85,10.85,0,0,0,.22,1.29c.1.4.24.8.32,1.21a2.72,2.72,0,0,1-.12,1.57,13.18,13.18,0,0,1-.73,1.33,4,4,0,0,0-.67,2.12,3.34,3.34,0,0,1,0,1.18,2.54,2.54,0,0,1-.51.85,10.36,10.36,0,0,0-1.31,1.5.16.16,0,0,0,0,.08,6.91,6.91,0,0,1-1.82,1.1,7.06,7.06,0,0,1-3.06.48,10.56,10.56,0,0,0-2.05-1.08,23.83,23.83,0,0,1-2.44-1,6.87,6.87,0,0,1-1.08-.7c-.33-.27-.62-.58-1-.84-.66-.49-1.41-.85-2-1.38a3.59,3.59,0,0,1-.87-1.07c-.2-.39-.35-.81-.53-1.22a3.86,3.86,0,0,0-.67-1.1,10.31,10.31,0,0,0-.94-.93c-.43-.39-.88-.76-1.31-1.14a34.21,34.21,0,0,1-1.6-3.27,6.25,6.25,0,0,1,.58-1.35c.35-.65.75-1.26,1.11-1.91a.18.18,0,0,0-.09-.25,17.26,17.26,0,0,1-1.76-.4,2.35,2.35,0,0,1-1.13-.63,2.08,2.08,0,0,1-.44-.78C1040.34,445.59,1040.27,445.25,1040.2,444.91Z"
            fill="#396039"
          />
          <path
            d="M1045.72,429.82a123,123,0,0,1,8,17.36c2.31,5.95,4.3,12,6.14,18.13s3.36,12.32,4.83,18.53c.72,3.11,1.36,6.23,2,9.35l1.76,9.41-1.91-9.38c-.71-3.11-1.36-6.23-2.1-9.33-1.5-6.2-3.06-12.39-4.93-18.49s-3.76-12.18-6-18.15l-1.76-4.44c-.62-1.47-1.21-2.95-1.87-4.4A91,91,0,0,0,1045.72,429.82Z"
            fill="#78bf3a"
          />
        </g>
        <g>
          <path
            d="M1075.69,472.17c0-.77,0-1.53-.09-2.29a50.74,50.74,0,0,1,3.5-11.25c.38-.37.75-.74,1.09-1.14s.78-1,1.16-1.55l1.33-1.82a15.68,15.68,0,0,0,2.14-3.75c.24-.67.33-1.37.51-2.06.12-.46.28-.92.44-1.37,4.36-5.84,8.93-9,11.76-7.68a3.26,3.26,0,0,1,1,.79c.06.2.12.41.17.62a8.8,8.8,0,0,1,.27,2.89,13.24,13.24,0,0,1-.57,2.77,18.92,18.92,0,0,0-.94,3.2,11.91,11.91,0,0,0,.12,3,14.38,14.38,0,0,1,.22,3.07,4.11,4.11,0,0,1-.88,2.53,7.47,7.47,0,0,1-1.62,1.16,7.79,7.79,0,0,0-1.72,1.62,2.13,2.13,0,0,0-.6,1.63c.07.63.34,1.23.45,1.86a5.25,5.25,0,0,1-1.31,4.17,20.34,20.34,0,0,1-3.55,3.06c-.67.51-1.33,1-2,1.59-.31.28-.62.58-.91.89s-.63.74-.94,1.11a19,19,0,0,1-4.69,3.61c-.85.52-1.68,1.05-2.47,1.64-1.43-.72-2.22-2.53-2.4-5.08A12.34,12.34,0,0,0,1075.69,472.17Z"
            fill="#2f4f2f"
          />
          <path
            d="M1098.6,438.81q-2.52,3.69-4.82,7.5t-4.54,7.68q-4.4,7.77-8.14,15.87a172.28,172.28,0,0,0-6.65,16.53c-.86,2.85-1.81,5.67-2.46,8.57-.82,2.86-1.26,5.81-1.83,8.73a105.61,105.61,0,0,1,4.08-17.37,170.32,170.32,0,0,1,6.56-16.6q3.79-8.09,8.25-15.84C1092,448.72,1095.16,443.66,1098.6,438.81Z"
            fill="#87f139"
          />
        </g>
        <g>
          <path
            d="M1076,476.49c.1-.6.16-1.21.22-1.81a39.67,39.67,0,0,1,4.17-8.37c.34-.24.68-.49,1-.75s.75-.71,1.11-1.08l1.27-1.25a12.34,12.34,0,0,0,2.16-2.67c.27-.5.43-1,.66-1.55a10.88,10.88,0,0,1,.52-1c4.16-4,8.15-5.95,10.19-4.52a2.51,2.51,0,0,1,.7.75c0,.17,0,.33.07.5a7.11,7.11,0,0,1-.16,2.3,10.45,10.45,0,0,1-.8,2.1,14.53,14.53,0,0,0-1.14,2.39,8.82,8.82,0,0,0-.29,2.4,12.34,12.34,0,0,1-.22,2.43,3.33,3.33,0,0,1-1,1.88,6,6,0,0,1-1.41.7,6.11,6.11,0,0,0-1.56,1.05,1.72,1.72,0,0,0-.68,1.2c0,.51.12,1,.12,1.52a4.2,4.2,0,0,1-1.55,3.1,16.4,16.4,0,0,1-3.18,1.94c-.59.32-1.17.64-1.73,1-.28.19-.56.38-.83.59s-.58.5-.88.75a15.43,15.43,0,0,1-4.13,2.23c-.73.3-1.45.61-2.14,1-1-.75-1.42-2.27-1.24-4.28A10.37,10.37,0,0,0,1076,476.49Z"
            fill="#396039"
          />
          <path
            d="M1098.17,453.25q-2.43,2.58-4.72,5.28c-1.55,1.78-3.06,3.6-4.53,5.44q-4.43,5.53-8.39,11.41a137.6,137.6,0,0,0-7.32,12.11c-1,2.11-2.14,4.2-3,6.39s-1.73,4.39-2.55,6.61a83,83,0,0,1,5.38-13.11,136.21,136.21,0,0,1,7.24-12.19q4-5.85,8.49-11.35A141.06,141.06,0,0,1,1098.17,453.25Z"
            fill="#78bf3a"
          />
        </g>
        <g>
          <path
            d="M1065.88,476.82a.79.79,0,0,0,.34-.56.9.9,0,0,0-.35-.65,6.46,6.46,0,0,0-1-.8v0a5.26,5.26,0,0,0,.62-.63,1,1,0,0,0,.27-.55c0-.4-.41-.59-.72-.71s-.44-.17-.67-.24c-.14-.69-.28-1.41-.4-2.16l.39-.1a6.48,6.48,0,0,0,1-.32,1.73,1.73,0,0,0,.67-.42.18.18,0,0,0,0-.27c-.31-.17-.64-.29-1-.44a2.13,2.13,0,0,1-.84-.54c-.24-.31-.06-.67-.06-1a.9.9,0,0,0-.38-.68l-.32-.27c-.1-.89-.18-1.8-.25-2.74l.55-.16a2.94,2.94,0,0,0,1.25-.65,1.06,1.06,0,0,0,.19-1.26,2.45,2.45,0,0,0-1.26-.93,6.61,6.61,0,0,0-.79-.25c0-.32-.11-.64-.16-1,0-.91-.05-1.85-.05-2.79a.44.44,0,0,1,.08-.11,1.46,1.46,0,0,1,.52-.32,3,3,0,0,0,.78-.59.17.17,0,0,0,0-.24c-.37-.31-1.27-.77-1-1.39.07-.18.36-.2.51-.28a.5.5,0,0,0,.27-.56c-.12-.42-.63-.58-.86-.91s.4-.5.65-.52a7.7,7.7,0,0,0,1.36,0,.17.17,0,0,0,0-.3c-.7-.5-1.39-1-2.12-1.44.13-2,.32-3.83.56-5.58l.31.09a.17.17,0,0,0,.2-.15,7,7,0,0,1,1.33.69c.24.17.48.35.71.54s.4-.09.24-.23a6.94,6.94,0,0,0-.76-.58,13.42,13.42,0,0,0-1.92-1.16c.23-1.53.5-3,.81-4.27a6.93,6.93,0,0,1,1.64.86l.59.54a.17.17,0,0,0,.24-.24,4.68,4.68,0,0,0-.62-.56c-.39-.36-.78-.72-1.18-1.06l-.47-.38a27.15,27.15,0,0,1,1.17-3.65,21.07,21.07,0,0,0,2.2.89.18.18,0,0,0,.21-.16,3.6,3.6,0,0,0-.81-1.81,7.34,7.34,0,0,0-.7-.79c.81-1.36,1.7-2.12,2.63-2.12,1.9,0,3.61,3.1,4.81,8.06-.49.44-1,.91-1.44,1.38a.17.17,0,0,0,.2.26,11.3,11.3,0,0,0,1.39-1c.3,1.31.56,2.73.79,4.26a24,24,0,0,0-1.48,3,.19.19,0,0,0,.06.23c.62.32,1.27.58,1.9.87.2,2.16.32,4.45.36,6.83a12.79,12.79,0,0,0-1.32,3.09,6.85,6.85,0,0,0-.11,2.47c0,.41.08.82.11,1.23s0,.81.07,1.21c.11.76.4,1.49.53,2.25a1.85,1.85,0,0,1-.51,1.86,4.21,4.21,0,0,1-1.38.53.63.63,0,0,0-.41.35.79.79,0,0,0,.11.63,3.37,3.37,0,0,0,1.43,1.21l.52.29c-1.16,7.32-3.25,12.21-5.63,12.21-1.46,0-2.82-1.86-3.92-5A2.16,2.16,0,0,0,1065.88,476.82Z"
            fill="#659965"
          />
          <path
            d="M1069.47,439.46c.29,10.57.37,21.14.49,31.71V487c-.06,5.29,0,10.59-.48,15.85.25-2.63.2-5.28.24-7.92l0-7.93-.1-15.85Z"
            fill="#78bf3a"
          />
        </g>
        <g>
          <path
            d="M1059.12,451a2.05,2.05,0,0,1,1.25,0c.23.3.46.6.7.89s.74.88,1.14,1.29a11.66,11.66,0,0,1,1.08,1.25,10.91,10.91,0,0,1,1.25,2.27,10.34,10.34,0,0,0,1.3,2.62c.51.63,1.16,1.1,1.72,1.67l0,0c.14.38.27.77.4,1.16a31.31,31.31,0,0,1,1.55,7.48q0,.3-.06.6a47.47,47.47,0,0,0-1,5.41,2.16,2.16,0,0,1-1,.78c-2.59.85-6.56-4.16-8.87-11.19S1056.53,451.89,1059.12,451Z"
            fill="#3b6818"
          />
          <path
            d="M1058.62,465.3s11.13,5.67,11.51,34.93"
            fill="none"
            stroke="#78bf3a"
            strokeMiterlimit="10"
            strokeWidth="0.33"
          />
          <path
            d="M1060.87,453.69a6.31,6.31,0,0,1,1.54,2.91,13.59,13.59,0,0,0,.63,3.08,4.25,4.25,0,0,0,1,1.38c.4.37.83.69,1.22,1.08a3.33,3.33,0,0,1,.89,1.48,2.79,2.79,0,0,1,0,1.32,6.21,6.21,0,0,0-.2,1.37,4.52,4.52,0,0,0,.56,1.85,5.14,5.14,0,0,1,.56,1.9,4,4,0,0,1-.21,1.21,3.62,3.62,0,0,0-.08,1.32,3.47,3.47,0,0,0,.41,1.21,2.56,2.56,0,0,1,.37,1,3.33,3.33,0,0,1-.48,1.55l-.08.16a1.18,1.18,0,0,1-.45.27c-2,.67-5.58-4.48-7.89-11.51s-2.54-13.27-.5-13.94a1.49,1.49,0,0,1,.86,0A13.26,13.26,0,0,0,1060.87,453.69Z"
            fill="#659965"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M1060.89,470.86a9,9,0,0,0,.09-1,7.41,7.41,0,0,0,0-1.49c-.06-.45-.19-.88-.29-1.31a4.25,4.25,0,0,1-.13-1.17c0-.43.14-.85.17-1.27a2.94,2.94,0,0,0-.09-1c-.08-.22-.17-.43-.27-.64s-.24-.38-.37-.57a.08.08,0,0,1,0-.12,4.82,4.82,0,0,0-2.28-2,4.74,4.74,0,0,0-2.8-.19,1.29,1.29,0,0,1-.34.36,3.23,3.23,0,0,1-1,.38,2,2,0,0,0-1.09.56,11,11,0,0,0-.73,1.18,2.21,2.21,0,0,1-.49.52,2.53,2.53,0,0,1-.6.28,1.59,1.59,0,0,0-.63.39,4.73,4.73,0,0,0-.43.57,6.14,6.14,0,0,1-.5.52,4.83,4.83,0,0,0-.37.42,6.36,6.36,0,0,0-.78,2.5,3.68,3.68,0,0,1-.59,1.38,6.57,6.57,0,0,1-.87.88,2.83,2.83,0,0,0-.66.76,3.19,3.19,0,0,0-.3,1.39c-.06,1.15,0,2.29-.1,3.43a7.56,7.56,0,0,1-.14.83c-.06.26-.15.51-.2.78a1.74,1.74,0,0,0,.07,1c.13.3.32.57.47.86a2.49,2.49,0,0,1,.43,1.36,2.42,2.42,0,0,0,0,.76,1.79,1.79,0,0,0,.33.55,7,7,0,0,1,.85,1,.13.13,0,0,1,0,.06,4.54,4.54,0,0,0,1.18.7,4.49,4.49,0,0,0,2,.31,7.29,7.29,0,0,1,1.33-.69c.52-.22,1.07-.4,1.57-.67a5.1,5.1,0,0,0,.69-.45c.21-.18.4-.38.62-.54.43-.32.91-.55,1.31-.89a2.33,2.33,0,0,0,.56-.69c.13-.25.23-.52.34-.79a2.64,2.64,0,0,1,.43-.7,6.9,6.9,0,0,1,.61-.6l.84-.74a21.54,21.54,0,0,0,1-2.1,4.84,4.84,0,0,0-.37-.87c-.23-.42-.49-.81-.71-1.23a.11.11,0,0,1,0-.16c.38-.08.77-.14,1.14-.25a1.62,1.62,0,0,0,.72-.41,1.46,1.46,0,0,0,.28-.5C1060.8,471.3,1060.85,471.08,1060.89,470.86Z"
            fill="#396039"
          />
          <path
            d="M1057.34,461.15a58.69,58.69,0,0,0-2.7,5.52c-.84,1.88-1.6,3.78-2.34,5.7-1.46,3.83-2.72,7.74-3.88,11.68s-2.2,7.91-3.17,11.89c-.48,2-.9,4-1.35,6l-1.23,6,1.13-6.06c.44-2,.85-4,1.31-6,1-4,1.93-8,3.11-11.92s2.46-7.84,4-11.67A78.54,78.54,0,0,1,1057.34,461.15Z"
            fill="#78bf3a"
          />
        </g>
        <g>
          <path
            d="M1038.05,488.4c0-.49,0-1,.06-1.47a32.38,32.38,0,0,0-2.25-7.24c-.24-.24-.48-.48-.7-.73s-.5-.67-.75-1-.57-.78-.85-1.17a10,10,0,0,1-1.38-2.42c-.15-.43-.21-.88-.33-1.32s-.18-.59-.28-.88c-2.81-3.76-5.75-5.82-7.57-4.94a2.14,2.14,0,0,0-.66.5l-.12.4a6.09,6.09,0,0,0-.17,1.86,8.41,8.41,0,0,0,.37,1.78,11.79,11.79,0,0,1,.6,2.06,7.56,7.56,0,0,1-.07,2,8.68,8.68,0,0,0-.14,2,2.69,2.69,0,0,0,.56,1.64,5.45,5.45,0,0,0,1,.74,5.27,5.27,0,0,1,1.12,1,1.43,1.43,0,0,1,.38,1.05c-.05.41-.22.79-.29,1.2a3.35,3.35,0,0,0,.84,2.68,13.46,13.46,0,0,0,2.29,2c.43.33.85.66,1.25,1,.21.19.41.38.6.58s.4.48.6.71a12.26,12.26,0,0,0,3,2.33c.54.33,1.08.67,1.59,1,.92-.46,1.43-1.63,1.54-3.27A8.19,8.19,0,0,1,1038.05,488.4Z"
            fill="#2f4f2f"
          />
          <path
            d="M1023.31,466.93a135.88,135.88,0,0,1,11.46,19.89,111.38,111.38,0,0,1,4.22,10.69,68,68,0,0,1,2.62,11.18,77.34,77.34,0,0,0-2.76-11.13,110.07,110.07,0,0,0-4.28-10.65q-2.4-5.21-5.23-10.21C1027.44,473.38,1025.46,470.1,1023.31,466.93Z"
            fill="#87f139"
          />
        </g>
        <g>
          <path
            d="M1037.87,491.18c-.06-.38-.11-.77-.14-1.16a26.15,26.15,0,0,0-2.68-5.39c-.23-.16-.44-.31-.65-.48s-.47-.46-.71-.69-.55-.54-.82-.81a7.62,7.62,0,0,1-1.38-1.72c-.18-.32-.28-.66-.43-1s-.21-.44-.33-.65c-2.68-2.59-5.25-3.83-6.57-2.91a1.59,1.59,0,0,0-.45.48c0,.11,0,.22,0,.32a4.59,4.59,0,0,0,.11,1.48,6.47,6.47,0,0,0,.51,1.35,8.78,8.78,0,0,1,.73,1.55,5.7,5.7,0,0,1,.19,1.54,7.42,7.42,0,0,0,.14,1.56,2.17,2.17,0,0,0,.66,1.21,3.79,3.79,0,0,0,.9.45,4.07,4.07,0,0,1,1,.68,1.08,1.08,0,0,1,.43.77c0,.33-.07.65-.07,1a2.66,2.66,0,0,0,1,2,10.15,10.15,0,0,0,2,1.25c.38.21.76.41,1.12.65a6.3,6.3,0,0,1,.53.37c.2.15.38.33.57.49a9.75,9.75,0,0,0,2.66,1.43c.47.19.93.39,1.37.62.67-.47.92-1.45.8-2.75A6.84,6.84,0,0,1,1037.87,491.18Z"
            fill="#396039"
          />
          <path
            d="M1023.59,476.23a105.5,105.5,0,0,1,11.52,14.12,86.05,86.05,0,0,1,4.66,7.84,52.93,52.93,0,0,1,3.47,8.44,61.83,61.83,0,0,0-3.59-8.37,89,89,0,0,0-4.71-7.79q-2.55-3.78-5.4-7.34C1027.63,480.76,1025.67,478.44,1023.59,476.23Z"
            fill="#78bf3a"
          />
        </g>
        <g>
          <path
            d="M1044.37,491.4a.52.52,0,0,1-.22-.36.62.62,0,0,1,.22-.43,6.34,6.34,0,0,1,.65-.51v0a3,3,0,0,1-.4-.4.67.67,0,0,1-.17-.36c0-.26.26-.37.46-.45l.43-.16c.1-.44.18-.91.26-1.39l-.25-.06a5.17,5.17,0,0,1-.63-.21,1.08,1.08,0,0,1-.43-.27.11.11,0,0,1,0-.17c.19-.11.41-.19.61-.29a1.38,1.38,0,0,0,.54-.34c.16-.2,0-.43,0-.66a.62.62,0,0,1,.25-.44l.2-.17c.06-.57.12-1.16.16-1.77l-.35-.1a1.87,1.87,0,0,1-.8-.42.67.67,0,0,1-.13-.8,1.57,1.57,0,0,1,.81-.6,5.08,5.08,0,0,1,.51-.17c0-.2.07-.41.11-.61,0-.59,0-1.19,0-1.8a.43.43,0,0,0,0-.07,1.08,1.08,0,0,0-.34-.21,1.7,1.7,0,0,1-.5-.38.1.1,0,0,1,0-.15c.24-.2.81-.5.65-.9,0-.11-.23-.12-.33-.18a.32.32,0,0,1-.17-.36c.07-.27.4-.37.55-.58s-.26-.33-.42-.33a6.47,6.47,0,0,1-.88,0c-.09,0-.09-.15,0-.2.45-.32.9-.64,1.37-.92-.09-1.27-.21-2.47-.37-3.59l-.19,0a.1.1,0,0,1-.13-.09,4.65,4.65,0,0,0-.86.44c-.16.11-.31.23-.46.35s-.26-.06-.15-.15a4.49,4.49,0,0,1,.49-.37,9.61,9.61,0,0,1,1.23-.75c-.15-1-.32-1.9-.52-2.74a4,4,0,0,0-1,.55l-.38.34c-.11.09-.25-.05-.16-.15a4.48,4.48,0,0,1,.4-.36c.25-.23.5-.46.76-.68l.3-.25a16.57,16.57,0,0,0-.75-2.34,14.26,14.26,0,0,1-1.41.56.11.11,0,0,1-.14-.1,2.31,2.31,0,0,1,.52-1.16c.14-.17.29-.35.45-.51-.52-.87-1.09-1.36-1.69-1.36-1.22,0-2.32,2-3.1,5.18.32.29.63.59.93.89a.11.11,0,0,1-.13.17,8.14,8.14,0,0,1-.9-.64c-.19.84-.36,1.76-.5,2.74a18.31,18.31,0,0,1,1,1.94.12.12,0,0,1,0,.15c-.4.21-.81.37-1.22.56-.13,1.39-.21,2.86-.24,4.39a8.15,8.15,0,0,1,.86,2,4.73,4.73,0,0,1,.07,1.59c0,.27-.06.53-.07.8s0,.51-.05.77c-.07.49-.25,1-.34,1.45a1.18,1.18,0,0,0,.33,1.2,2.74,2.74,0,0,0,.89.34.38.38,0,0,1,.26.22.54.54,0,0,1-.07.41,2.12,2.12,0,0,1-.92.78l-.34.19c.75,4.71,2.09,7.85,3.63,7.85.94,0,1.81-1.19,2.52-3.22Z"
            fill="#659965"
          />
          <path
            d="M1042.06,467.35l-.1,20.41-.07,10.2,0,5.1c0,1.7,0,3.41.15,5.1-.32-3.39-.27-6.8-.31-10.2v-10.2C1041.82,481,1041.87,474.15,1042.06,467.35Z"
            fill="#78bf3a"
          />
        </g>
        <g>
          <path
            d="M1048.72,474.8a1.36,1.36,0,0,0-.8,0c-.15.2-.3.39-.46.58s-.47.56-.73.82a10.69,10.69,0,0,0-.7.81,7.4,7.4,0,0,0-.8,1.46,6.84,6.84,0,0,1-.84,1.69c-.32.4-.74.7-1.1,1.07l0,0c-.09.25-.18.5-.26.75a20.14,20.14,0,0,0-1,4.82c0,.12,0,.25,0,.38a29.83,29.83,0,0,1,.61,3.48,1.34,1.34,0,0,0,.67.5c1.66.55,4.22-2.67,5.71-7.2S1050.38,475.35,1048.72,474.8Z"
            fill="#3b6818"
          />
          <path
            d="M1049,484s-7.16,3.65-7.41,22.49"
            fill="none"
            stroke="#78bf3a"
            strokeMiterlimit="10"
            strokeWidth="0.21"
          />
          <path
            d="M1047.59,476.51a4.13,4.13,0,0,0-1,1.87,8.92,8.92,0,0,1-.4,2,2.81,2.81,0,0,1-.65.89c-.26.24-.54.45-.79.7a2.09,2.09,0,0,0-.57.95,1.62,1.62,0,0,0,0,.85,4.24,4.24,0,0,1,.12.88,2.94,2.94,0,0,1-.36,1.19,3.36,3.36,0,0,0-.36,1.22,2.45,2.45,0,0,0,.14.78,2.45,2.45,0,0,1,0,.86,2.34,2.34,0,0,1-.26.77,1.59,1.59,0,0,0-.24.67,2.06,2.06,0,0,0,.3,1l.06.1a.64.64,0,0,0,.29.18c1.31.43,3.59-2.88,5.08-7.41s1.63-8.54.31-9a.87.87,0,0,0-.55,0A8.68,8.68,0,0,1,1047.59,476.51Z"
            fill="#659965"
          />
        </g>
      </g>
      <g>
        <g>
          <rect
            x="227.24"
            y="38.29"
            width="1.91"
            height="33.71"
            rx="0.95"
            fill="#a39bb2"
          />
          <g>
            <ellipse
              cx="228.19"
              cy="29.36"
              rx="3.91"
              ry="0.77"
              fill="url(#fabcea19-7839-4f63-bae5-8966340f1494)"
            />
            <ellipse
              cx="228.19"
              cy="30.7"
              rx="5.39"
              ry="1.01"
              fill="url(#bb975892-7ec6-4436-ba5f-b9ed66a870a5)"
            />
            <ellipse
              cx="228.19"
              cy="32.03"
              rx="6.88"
              ry="1.25"
              fill="url(#b0615de8-43cc-4e2a-b640-ca08860867dc)"
            />
            <ellipse
              cx="228.19"
              cy="33.37"
              rx="8.36"
              ry="1.49"
              fill="url(#becf2053-0de1-4516-90be-51955962a905)"
            />
            <ellipse
              cx="228.19"
              cy="34.7"
              rx="9.84"
              ry="1.72"
              fill="url(#b67441f8-64ba-4bee-9b53-4e2d12397581)"
            />
            <ellipse
              cx="228.19"
              cy="36.04"
              rx="11.33"
              ry="1.96"
              fill="url(#be59a214-4223-4739-9640-4e8c04674d04)"
            />
            <ellipse
              cx="228.19"
              cy="38"
              rx="10.21"
              ry="1.8"
              fill="url(#b847d2c3-2a37-4d26-97bc-a0c6abc6fb3b)"
            />
            <ellipse
              cx="228.19"
              cy="39.97"
              rx="9.1"
              ry="1.63"
              fill="url(#ec58e84a-cea0-4a9f-baec-6fb7ffe98f2b)"
            />
            <ellipse
              cx="228.19"
              cy="41.94"
              rx="7.99"
              ry="1.46"
              fill="url(#b686e5fd-cf22-4887-9fd2-cd0a503b43c3)"
            />
            <ellipse
              cx="228.19"
              cy="43.91"
              rx="6.87"
              ry="1.3"
              fill="url(#b7c8b974-39eb-4334-bfe4-311f10ef63f8)"
            />
            <ellipse
              cx="228.19"
              cy="45.87"
              rx="5.76"
              ry="1.13"
              fill="url(#b75ea7aa-3199-4791-a9c7-c901e2ecdafb)"
            />
          </g>
        </g>
        <circle
          cx="228"
          cy="37"
          r="19"
          fill="url(#a32a3007-e261-434c-9acc-5bc9f23d39f1)"
        />
      </g>
    </g>
  );
};

export default Decor4;
